<!-- eslint-disable standard/computed-property-even-spacing -->
<template>
  <div class="page-assets">
    <nav-header @selectFunc="selectFunc" @navSelect="navSelect"></nav-header>
    <div class="page-assets-content flex">
      <div class="country-asset-box">
        <!-- <div class="logo-box">
        <img class="logo" src="../assets/img/logo-blue.png" alt="" />
      </div> -->
        <div class="country-asset-list">
          <!-- 站点列表 -->
          <div class="asset-list">
            <h4>{{ $t("m.assetsManagement") }}</h4>
            <div class="asset-list-content">
              <a-tree
                class="draggable-tree"
                block-node
                :tree-data="siteList"
                :replaceFields="replaceFields"
                :defaultSelectedKeys="defaultSelectedKeys"
                :defaultExpandedKeys="defaultSelectedKeys"
                :showLine="true"
                v-if="siteList.length"
              >
                <template slot="site" slot-scope="item">
                  <div
                    class="site"
                    :class="{
                      selected:
                        selectedAssetObj.spSiteId == item.spSiteId &&
                        selectedLevel == 'site'
                    }"
                    @click="selectSiteOrAsset(item)"
                  >
                    <img src="../assets/img/icon-tree/site.svg" alt="" />
                    <span>{{ item.name }}</span>
                    <i
                      class="el-icon-view"
                      @click.stop="showAssetDetailModal(item, 'site', 'site')"
                    ></i>
                  </div>
                </template>
                <template slot="system" slot-scope="item">
                  <div
                    @click="selectSiteOrAsset(item)"
                    :class="{
                      'tree-disabled': judgeTreeDisabled(),
                      selected:
                        selectedAssetObj.spSystemId == item.spSystemId &&
                        selectedLevel == 'system'
                    }"
                  >
                    <img src="../assets/img/icon-tree/system.svg" alt="" />
                    <span>{{ item.name }}</span>
                    <i
                      class="el-icon-view"
                      @click.stop="
                        showAssetDetailModal(item, 'system', 'system')
                      "
                    ></i>
                  </div>
                </template>
                <template slot="load" slot-scope="item">
                  <div
                    @click="selectSiteOrAsset(item)"
                    :class="{
                      'tree-disabled': judgeTreeDisabled(),
                      selected:
                        selectedAssetObj.spAssetId == item.spAssetId &&
                        selectedLevel == 'load'
                    }"
                  >
                    <img src="../assets/img/icon-tree/load.svg" alt="" />
                    <span>{{ item.name }}</span>
                    <i
                      class="el-icon-view"
                      @click.stop="showAssetDetailModal(item, 'site', 'site')"
                    ></i>
                  </div>
                </template>
                <template slot="asset-pv" slot-scope="item">
                  <div
                    @click="selectSiteOrAsset(item)"
                    :class="{
                      'tree-disabled': judgeTreeDisabled(),
                      selected:
                        selectedAssetObj.spAssetId == item.spAssetId &&
                        selectedLevel == 'asset-pv'
                    }"
                  >
                    <img src="../assets/img/icon-tree/PV.svg" alt="" />
                    <span>{{ item.name }}</span>
                    <i
                      class="el-icon-view"
                      @click.stop="
                        showAssetDetailModal(item, 'asset', 'asset-pv')
                      "
                    ></i>
                  </div>
                </template>
                <template slot="asset-bess" slot-scope="item">
                  <div
                    @click="selectSiteOrAsset(item)"
                    :class="{
                      'tree-disabled': judgeTreeDisabled(),
                      selected:
                        selectedAssetObj.spAssetId == item.spAssetId &&
                        selectedLevel == 'asset-bess'
                    }"
                  >
                    <img src="../assets/img/icon-tree/BESS.svg" alt="" />
                    <span>{{ item.name }}</span>
                    <i
                      class="el-icon-view"
                      @click.stop="
                        showAssetDetailModal(item, 'asset', 'asset-bess')
                      "
                    ></i>
                  </div>
                </template>
                <template slot="asset-charging" slot-scope="item">
                  <div
                    @click="selectSiteOrAsset(item)"
                    :class="{
                      'tree-disabled': judgeTreeDisabled(),
                      selected:
                        selectedAssetObj.spAssetId == item.spAssetId &&
                        selectedLevel == 'asset-charging'
                    }"
                  >
                    <img src="../assets/img/icon-tree/charging.svg" alt="" />
                    <span>{{ item.name }}</span>
                    <i
                      class="el-icon-view"
                      @click.stop="
                        showAssetDetailModal(item, 'asset', 'asset-charging')
                      "
                    ></i>
                  </div>
                </template>
                <template slot="Terminal" slot-scope="item">
                  <p class="tree-disabled">{{ item.name }}</p>
                </template>
                <template slot="Connector" slot-scope="item">
                  <p class="tree-disabled">{{ item.name }}</p>
                </template>
              </a-tree>
            </div>
          </div>
        </div>
      </div>
      <!-- Operations -->
      <div class="charts-data flex" v-if="selectedTopNav == '1'">
        <div class="charts-data-content">
          <div class="header flex flex-main-justify">
            <div class="flex flex-cross-center header-content">
              <div
                v-for="item in siteViewList"
                :key="item.id"
                class="cycle flex flex-cross-center"
                :class="{ active: item.id == selectedSiteView }"
                @click="changeSiteView(item.id)"
              >
                <span>{{ item.value }}</span>
              </div>
            </div>
            <div
              class="event-filter-box flex flex-cross-center"
              v-show="selectedSiteView == '2'"
            >
              <div
                class="filter-out-btn flex flex-cross-center flex-main-center"
                @click="reserveEventFilterBoxShow"
              >
                <img src="../assets/img/filter.svg" alt="" />
                <span>{{ $t("m.filter") }}</span>
              </div>
              <div class="event-filter-popover" v-show="eventFilterBoxShow">
                <el-select v-model="eventListFilter.system">
                  <el-option
                    v-for="item in systemList"
                    :key="item.spSystemId"
                    :label="item.systemName"
                    :value="item.spSystemId"
                  >
                  </el-option>
                </el-select>
                <el-select v-model="eventListFilter.eventType">
                  <el-option
                    v-for="item in eventsTypeOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <el-button
                  type="primary"
                  class="filter-btn"
                  @click="handleFilterClick"
                  >{{ $t("m.filter") }}</el-button
                >
                <el-button
                  type="primary"
                  class="reset-btn"
                  plain
                  @click="resetEventFilter"
                  >{{ $t("m.reset") }}</el-button
                >
              </div>
            </div>
          </div>
          <!-- 选中日期的收益(今天或历史才有数据) -->
          <el-row class="info-list operations-info-list">
            <el-col :span="4">
              <div class="info-one">
                <p class="param-name">{{ $t("m.total") }}</p>
                <p class="param-value">
                  {{
                    getMoneyUnit() +
                      " " +
                      handleDataEmptyShow(eventsTopData.total)
                  }}
                </p>
              </div>
            </el-col>
            <el-col
              :span="siteHaveBESS() ? 8 : 4"
              :offset="1"
              class="flex benefits"
            >
              <div class="info-one flex">
                <div class="param-box" :class="{ 'w-100': !siteHaveBESS() }">
                  <p class="param-name">{{ $t("m.ultraFastCharging") }}</p>
                  <p class="param-value">
                    {{
                      getMoneyUnit() +
                        " " +
                        handleDataEmptyShow(eventsTopData.ultraFastCharging)
                    }}
                  </p>
                </div>
                <div class="param-box ancillary-service" v-if="siteHaveBESS()">
                  <p class="param-name">{{ $t("m.ancillaryService") }}</p>
                  <p class="param-value">
                    {{
                      getMoneyUnit() +
                        " " +
                        handleDataEmptyShow(eventsTopData.ancillaryService)
                    }}
                  </p>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- Operations modes -->
          <div class="dashboard-box" v-show="selectedSiteView == '1'">
            <el-table
              class="site-plan-table"
              :data="sitePlanList"
              style="width: 100%"
            >
              <el-table-column prop="date" label="Date" width="100">
              </el-table-column>
              <el-table-column
                prop="siteName"
                :label="$t('m.siteName')"
                width="130"
              >
              </el-table-column>
              <el-table-column
                prop="systemName"
                :label="$t('m.systemName')"
                width="130"
              >
              </el-table-column>
              <el-table-column
                prop="Benefits"
                :label="$t('m.benefits') + '(' + getMoneyUnit() + ')'"
                width="100"
                v-show="isHistoryDate()"
              >
              </el-table-column>
              <el-table-column
                prop="Mode"
                :label="
                  $t('m.mode') +
                    ' (The bottom part is the system execution plan, and the others are conflicting plans, which can be modified through editing)'
                "
                label-class-name="mode-text"
              >
                <template slot-scope="scope">
                  <el-row
                    v-for="(plan, index) in scope.row.plansInfoList"
                    :key="index"
                  >
                    <span
                      v-for="(item, index) in plan.infoList"
                      :key="index"
                      :style="{
                        width: (1 / timeArr.length) * 100 * item.splitNum + '%'
                      }"
                      class="cp event-one"
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="handleEventDetailShow(item)"
                        placement="top"
                      >
                        <div
                          v-if="isFutureTime()"
                          class="grid-content future-time"
                          :class="planModeClass[item.modeType]"
                        ></div>
                        <div
                          v-else
                          class="grid-content"
                          :class="planModeClass[item.modeType]"
                        ></div> </el-tooltip
                    ></span>
                  </el-row>
                  <el-row class="time-list">
                    <!-- <el-col
                      v-for="(item, index) in timeArr"
                      :key="index"
                      :span="1"
                      ><span class="time">{{ item }}</span></el-col
                    >
                    <el-col :span="1"
                      ><span class="special-time">24:00</span></el-col
                    > -->
                    <span
                      v-for="(item, index) in timeArr"
                      :key="index"
                      class="time"
                      :style="{ width: (1 / timeArr.length) * 100 + '%' }"
                      >{{ item }}</span
                    >
                    <!-- <span class="special-time">24:00</span> -->
                  </el-row>
                </template>
              </el-table-column>
              <!-- 编辑计划 -->
              <el-table-column
                :label="$t('m.operations')"
                width="90"
                v-if="isFutureDate()"
              >
                <template slot-scope="scope">
                  <div class="operate">
                    <el-popover
                      placement="left"
                      trigger="hover"
                      class="cp"
                      popper-class="plan-operate-popper"
                    >
                      <div>
                        <p
                          class="cp"
                          @click="showPlanModal('edit-one', scope.row)"
                        >
                          {{ $t("m.dailyPlan") }}
                        </p>
                        <p
                          class="cp"
                          @click="showPlanModal('edit-all', scope.row)"
                        >
                          {{ $t("m.recurringPlan") }}
                        </p>
                      </div>
                      <img
                        slot="reference"
                        src="../assets/img/Edit.svg"
                        alt=""
                      />
                    </el-popover>
                    <img
                      src="../assets/img/Delete.svg"
                      class="cp"
                      alt=""
                      @click="deletePlan(scope.row)"
                    />
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- events -->
          <div class="events-box" v-if="selectedSiteView == '2'">
            <div v-if="eventList.length">
              <el-table
                class="event-list-table"
                :data="eventList"
                style="width: 100%"
                :height="400"
              >
                <el-table-column
                  prop="no"
                  :label="$t('m.chargingPileNo')"
                  width="80"
                >
                </el-table-column>
                <el-table-column
                  prop="state"
                  :label="$t('m.state')"
                  width="130"
                >
                  <template slot-scope="scope">
                    {{ eventStateTextObj[scope.row.state] }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="siteName"
                  :label="$t('m.siteName')"
                  width="130"
                >
                </el-table-column>
                <el-table-column
                  prop="systemName"
                  :label="$t('m.systemName')"
                  width="130"
                >
                </el-table-column>
                <el-table-column prop="date" :label="$t('m.date')" width="130">
                </el-table-column>
                <el-table-column
                  prop="Period"
                  :label="$t('m.period')"
                  width="130"
                >
                </el-table-column>
                <el-table-column
                  prop="event"
                  :label="$t('m.event')"
                  width="160"
                >
                  <template slot-scope="scope">
                    {{ eventsTypeTextObj[scope.row.type] }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="desc"
                  :label="$t('m.desc')"
                  width="130"
                  v-if="selectedSiteInfo.bindingBillTypeCodeList.includes('40')"
                >
                  <template slot-scope="scope">
                    {{ eventsDescTextObj[scope.row.son_type] || "-" }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="total_revenues"
                  :label="$t('m.benefits') + '(' + getMoneyUnit() + ')'"
                  width="130"
                >
                  <template slot-scope="scope">
                    {{ handleDataEmptyShow(scope.row.total_revenues) }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="total_revenues"
                  :label="$t('m.performance') + '(' + '%' + ')'"
                  width="130"
                  v-if="selectedSiteInfo.bindingBillTypeCodeList.includes('40')"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.type == 20
                        ? handleDataEmptyShow(scope.row.performance * 100)
                        : "/"
                    }}
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="eventListFilter.currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="eventListFilter.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="eventListFilter.total"
              >
              </el-pagination>
            </div>
            <div
              class="no-data-box flex flex-cross-center flex-main-center"
              v-else
            >
              <img src="../assets/img/No record.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- Dashboard -->
      <div class="charts-data" v-if="selectedTopNav == '2'">
        <page-dashboard
          :selectedAssetDetail="selectedAssetObj"
          :selectedSiteInfo="selectedSiteInfo"
          :selectedCalendarDate="selectedDataDay"
          :selectedLevel="selectedLevel"
          :planList="sitePlanList"
          :realTime="realTime"
        ></page-dashboard>
      </div>
      <!-- 账单页 -->
      <div class="configuration-box" v-if="selectedTopNav == '3'">
        <page-my
          :selectedAssetObj="selectedAssetObj"
          :selectedSiteInfo="selectedSiteInfo"
        ></page-my>
      </div>
      <div
        class="calendar-box"
        v-if="selectedTopNav == '1' || selectedTopNav == '2'"
      >
        <div class="current-time-box flex flex-dir-top flex-cross-center">
          <p class="time-text">
            {{ selectedSiteInfo.timeZoneId || $t("m.assetTimezone") }}
          </p>
          <p class="time-value" :class="{ hidden: !isToday() }">
            {{ selectedSiteInfo.timeZoneId ? realTime : $t("m.emptyDataTip") }}
          </p>
          <p>{{ selectedSiteInfo.timeZoneId ? realDate : "" }}</p>
        </div>
        <div>
          <el-calendar class="plan-calendar" v-if="calendarShow">
            <template slot="dateCell" slot-scope="{ data }">
              <div
                class="date-cell"
                @click="handleDateSelect(data.day, $event)"
                :class="{ disabled: futureTimeLimitSelect(data.day) }"
              >
                <p :data-day="data.day">
                  {{ data.day.split("-")[2] }}
                </p>
                <div class="event-box flex flex-cross-center flex-main-center">
                  <span
                    class="event-one energySaving"
                    v-if="
                      calendarEventsList[data.day] &&
                        calendarEventsList[data.day][30]
                    "
                  ></span>
                  <span
                    class="event-one ultraFastCharging"
                    v-if="
                      calendarEventsList[data.day] &&
                        calendarEventsList[data.day][10]
                    "
                  ></span>
                  <span
                    class="event-one AncillaryService"
                    v-if="
                      calendarEventsList[data.day] &&
                        calendarEventsList[data.day][20]
                    "
                  ></span>
                </div>
              </div>
            </template>
          </el-calendar>
          <div class="mode-list flex">
            <!-- <div class="mode-one">
              <i class="mode-cycle energySaving"></i>
              <span>{{ $t("m.energySaving") }}</span>
            </div> -->
            <div class="mode-one">
              <i class="mode-cycle ultraFastCharging"></i>
              <span>{{ $t("m.ultraFastCharging") }}</span>
            </div>
            <div
              class="mode-one"
              v-if="selectedSiteInfo.bindingBillTypeCodeList.includes('40')"
            >
              <i class="mode-cycle AncillaryService"></i>
              <span>{{ $t("m.ancillaryService") }}</span>
            </div>
          </div>
        </div>
        <el-button
          type="primary"
          class="create-plan-btn"
          @click="showPlanModal('add')"
          v-show="selectedTopNav == '1'"
          ><i class="el-icon-plus"></i
          >{{ $t("m.createBtn") + " " + $t("m.plan") }}</el-button
        >
      </div>
    </div>
    <!-- 新增/编辑计划 -->
    <div class="modal plan-modal" v-if="planModalShow">
      <div class="modal-body tvac" v-if="planIsSaved">
        <i class="el-icon-error" @click="hidePlanModal"></i>
        <h4>
          <i class="el-icon-arrow-left cp" @click="backEditPlan"></i
          ><span>Return mode plan</span>
        </h4>
        <el-calendar class="modal-plan-calendar">
          <template slot="dateCell" slot-scope="{ data }">
            <p>{{ data.day.split("-")[2] }}</p>
            <p
              class="event-one"
              :class="planModeClass[item.mode]"
              v-for="(item, index) in modalCalendarEventsList[data.day]"
              :key="index"
            >
              {{ item.title }}
            </p>
          </template>
        </el-calendar>
        <el-button type="primary" @click="hidePlanModal">{{
          $t("m.completeBtn")
        }}</el-button>
      </div>
      <div class="modal-body tvac" v-else>
        <i class="el-icon-error" @click="hidePlanModal"></i>
        <el-form
          ref="plan-form"
          :model="planForm"
          :rules="planFormRule"
          label-width="0"
        >
          <h4>{{ planModalTitleObj[planOperateMode] }}</h4>
          <el-row>
            <el-col :span="10">
              <el-form-item :label="$t('m.site')" prop="site">
                <el-select v-model="planForm.site" :disabled="true">
                  <el-option
                    v-for="item in siteList"
                    :key="item.spSiteId"
                    :label="item.siteName"
                    :value="item.spSiteId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10" :offset="4">
              <el-form-item :label="$t('m.system')" prop="system">
                <el-select
                  v-model="planForm.system"
                  @change="planFormSelectSystem"
                  :disabled="isPlanEdit()"
                >
                  <el-option
                    v-for="item in systemList"
                    :key="item.spSystemId"
                    :label="item.systemName"
                    :value="item.spSystemId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('m.startDate')" prop="startDate">
                <el-date-picker
                  v-model="planForm.startDate"
                  type="date"
                  placeholder="Please select"
                  :picker-options="pickerOptions"
                  :disabled="isPlanEdit()"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="isPlanEdit()">
              <el-form-item :label="$t('m.mode')" prop="mode">
                <el-select
                  v-model="planForm.mode"
                  @change="handlePlanModeChange"
                  :class="
                    selectedEditPlanDetail.isConflict ? 'is-conflict' : ''
                  "
                >
                  <el-option
                    v-for="item in planForm.planList"
                    :key="item.key"
                    :label="item.name"
                    :value="item.key"
                    :class="item.isConflict ? 'is-conflict' : ''"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-show="planOperateMode == 'edit-all'">
              <el-form-item :label="$t('m.startDate')" prop="startDate">
                <el-date-picker
                  v-model="planForm.startDate"
                  type="date"
                  placeholder="Please select"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-row
              class="plan-one clearfix pr"
              v-if="isPlanEdit() && !selectedPlanIsDelete"
            >
              <el-col :span="5">
                <p class="el-form-item__label">
                  {{ $t("m.plan") }}
                </p>
                <el-select
                  v-model="planForm.plan"
                  @change="planFormSelectPlanType($event)"
                  :class="
                    selectedEditPlanDetail.isConflict ? 'is-conflict' : ''
                  "
                >
                  <el-option
                    v-for="item in planModeList"
                    :key="item.modeType"
                    :label="item.modeName"
                    :value="item.modeType"
                  ></el-option>
                </el-select>
              </el-col>
              <!-- Ansillary service需要选择desc -->
              <el-col :span="5" :offset="1" v-show="planForm.plan == 20">
                <p class="el-form-item__label">
                  {{ $t("m.desc") }}
                </p>
                <el-select v-model="planForm.desc">
                  <el-option
                    v-for="item in descList"
                    :key="item.modeSonType"
                    :label="item.modeSonName"
                    :value="item.modeSonType"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="11" :offset="1" class="time-between">
                <p class="el-form-item__label">
                  {{ $t("m.timeBetween") }}
                </p>
                <el-row class="flex">
                  <el-col :span="10">
                    <el-select v-model="planForm.startTime">
                      <el-option
                        v-for="(item, index) in timeStartList"
                        :key="index"
                        :label="item.time"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4" class="sign">~</el-col>
                  <el-col :span="10">
                    <el-select
                      v-model="planForm.endTime"
                      :class="
                        selectedEditPlanDetail.isConflict ? 'is-conflict' : ''
                      "
                    >
                      <el-option
                        v-for="(item, index) in timeEndList"
                        :key="index"
                        :label="item.time"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="1" class="pr operate">
                <img
                  src="../assets/img/Delete.svg"
                  class="img-delete cp"
                  alt=""
                  @click="showDeleteOnePlanModal()"
                />
              </el-col>
            </el-row>
            <div v-if="!isPlanEdit()">
              <el-row
                class="plan-one clearfix pr"
                v-for="(item, index) in planForm.planList"
                :key="index"
              >
                <el-col :span="5">
                  <p class="el-form-item__label">
                    {{ $t("m.plan") }}
                  </p>
                  <el-select
                    v-model="item.plan"
                    @change="planFormSelectPlanType($event, index)"
                  >
                    <el-option
                      v-for="item in planModeList"
                      :key="item.modeType"
                      :label="item.modeName"
                      :value="item.modeType"
                    ></el-option>
                  </el-select>
                </el-col>
                <!-- Ansillary service需要选择desc -->
                <el-col :span="5" :offset="1" v-show="item.plan == 20">
                  <p class="el-form-item__label">
                    {{ $t("m.desc") }}
                  </p>
                  <el-select v-model="item.desc">
                    <el-option
                      v-for="item in descList"
                      :key="item.modeSonType"
                      :label="item.modeSonName"
                      :value="item.modeSonType"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="11" :offset="1" class="time-between">
                  <p class="el-form-item__label">
                    {{ $t("m.timeBetween") }}
                  </p>
                  <el-row class="flex">
                    <el-col :span="10">
                      <el-select
                        v-model="item.startTime"
                        :placeholder="$t('m.startTime')"
                      >
                        <el-option
                          v-for="(item, index) in timeStartList"
                          :key="index"
                          :label="item.time"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="4" class="sign">~</el-col>
                    <el-col :span="10">
                      <el-select
                        v-model="item.endTime"
                        :placeholder="$t('m.endTime')"
                      >
                        <el-option
                          v-for="(item, index) in timeEndList"
                          :key="index"
                          :label="item.time"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="1" class="pr operate">
                  <el-popover
                    placement="bottom-end"
                    width="40"
                    trigger="hover"
                    popper-class="plan-one-operate-popper"
                    v-show="!isPlanEdit()"
                  >
                    <div class="cp" @click="addPlanOne(index)">
                      <el-button
                        size="mini"
                        type="text"
                        icon="el-icon-plus"
                      ></el-button>
                      <span>{{ $t("m.add") + " " + $t("m.plan") }}</span>
                    </div>
                    <div
                      v-show="planForm.planList.length > 1"
                      class="cp"
                      @click="showRemovePlanModal(index)"
                    >
                      <el-button
                        size="mini"
                        type="text"
                        icon="el-icon-delete"
                      ></el-button>
                      <span>{{ $t("m.delete") }}</span>
                    </div>
                    <i slot="reference" class="el-icon-more cp"></i>
                  </el-popover>
                </el-col>
              </el-row>
            </div>
            <el-col :span="24" v-if="planOperateMode != 'edit-one'">
              <el-form-item :label="$t('m.repetition')" prop="repetition">
                <el-select v-model="planForm.repetition">
                  <el-option
                    v-for="item in planRepetitionList"
                    :key="item.type"
                    :label="item.info"
                    :value="item.type"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="planForm.repetition == 20">
              <el-form-item :label="$t('m.weekly')" prop="weekly" key="weekly">
                <el-checkbox-group v-model="planForm.weekly" class="flex">
                  <el-checkbox-button label="Mon"></el-checkbox-button>
                  <el-checkbox-button label="Tue"></el-checkbox-button>
                  <el-checkbox-button label="Wed"></el-checkbox-button>
                  <el-checkbox-button label="Thu"></el-checkbox-button>
                  <el-checkbox-button label="Fri"></el-checkbox-button>
                  <el-checkbox-button label="Sat"></el-checkbox-button>
                  <el-checkbox-button label="Sun"></el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col
              :span="24"
              v-show="planForm.repetition == 10 || planForm.repetition == 20"
            >
              <el-form-item :label="$t('m.endDate')" prop="endDate">
                <el-date-picker
                  v-model="planForm.endDate"
                  type="date"
                  placeholder="Please select"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div>
          <el-button @click="hidePlanModal">{{ $t("m.cancelBtn") }}</el-button>
          <el-button type="primary" @click="handlePlanSubmit">{{
            $t("m.saveBtn")
          }}</el-button>
        </div>
      </div>
    </div>
    <div class="modal asset-edit-modal" v-show="editAssetModalShow">
      <div class="modal-body tvac">
        <div class="modal-header">
          <h4>{{ $t("m." + viewInfoMode) + " " + $t("m.information") }}</h4>
          <i class="el-icon-error" @click="hideEditAssetModal"></i>
        </div>
        <div class="modal-content">
          <el-form ref="form" :model="form" label-width="400">
            <!-- site -->
            <el-row v-if="operateMode.includes('site')">
              <el-col :span="10">
                <el-form-item :label="$t('m.siteName')" prop="siteName">
                  <el-input v-model="form.siteName" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="4">
                <el-form-item :label="$t('m.siteType')" prop="spSiteTypeId">
                  <el-select v-model="form.spSiteTypeId" disabled>
                    <el-option
                      v-for="item in siteTypeList"
                      :key="item.spSiteTypeId"
                      :label="item.siteTypeName"
                      :value="item.spSiteTypeId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :label="$t('m.owner')" prop="siteOwner">
                  <el-input v-model="form.siteOwner" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="4">
                <el-form-item :label="$t('m.country')" prop="spCountryId">
                  <el-select v-model="form.spCountryId" disabled>
                    <el-option
                      v-for="item in countryList"
                      :key="item.spCountryId"
                      :label="item.name"
                      :value="item.spCountryId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :label="$t('m.region')" prop="spRegionId">
                  <el-select v-model="form.spRegionId" disabled>
                    <el-option
                      v-for="item in regionList"
                      :key="item.spRegionId"
                      :label="item.name"
                      :value="item.spRegionId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="4">
                <el-form-item :label="$t('m.timeZone')" prop="spTimezoneId">
                  <el-select v-model="form.spTimezoneId" disabled>
                    <el-option
                      v-for="item in timezoneList"
                      :key="item.spTimezoneId"
                      :label="item.timezoneId"
                      :value="item.spTimezoneId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="$t('m.address')" prop="address">
                  <el-input v-model="form.address" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :label="$t('m.latitude')" prop="latitude">
                  <el-input v-model="form.latitude" type="number" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="4">
                <el-form-item :label="$t('m.longitude')" prop="longitude">
                  <el-input v-model="form.longitude" type="number" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item
                  :label="$t('m.maxImportCapacity') + ' (kW)'"
                  prop="maxImportCapacity"
                >
                  <el-input
                    v-model="form.maxImportCapacity"
                    type="number"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="4">
                <el-form-item
                  :label="$t('m.maxExportCapacity') + ' (kW)'"
                  prop="maxExportCapacity"
                >
                  <el-input
                    v-model="form.maxExportCapacity"
                    type="number"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  :label="$t('m.billType')"
                  prop="bindingBillTypeCodeList"
                >
                  <el-select
                    v-model="form.bindingBillTypeCodeList"
                    multiple
                    disabled
                  >
                    <el-option
                      v-for="item in billTypeList"
                      :key="item.billType"
                      :label="item.billTypeName"
                      :value="item.billType"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- meter list -->
              <el-row
                v-for="(meterOne, meterIndex) in form.meterList"
                :key="meterIndex + 1"
                class="meter-one clearfix"
              >
                <el-row :gutter="8" class="clearfix">
                  <div>
                    <el-col :span="2">
                      <p class="el-form-item__label">{{ $t("m.number") }}</p>
                      <el-input
                        disabled
                        class="meter-number-input"
                        :value="meterIndex + 1"
                      />
                    </el-col>
                    <el-col :span="4">
                      <p class="el-form-item__label">{{ $t("m.meterName") }}</p>
                      <el-input v-model="meterOne.meterName" disabled />
                    </el-col>
                    <el-col :span="5">
                      <p class="el-form-item__label">
                        {{ $t("m.meterNumber") }}
                      </p>
                      <el-input
                        v-model="meterOne.meterNum"
                        type="number"
                        disabled
                      />
                    </el-col>
                    <el-col :span="4">
                      <p class="el-form-item__label">{{ $t("m.meterType") }}</p>
                      <el-select v-model="meterOne.spMeterTypeId" disabled>
                        <el-option
                          v-for="item in meterTypeList"
                          :key="item.spMeterTypeId"
                          :label="item.meterTypeName"
                          :value="item.spMeterTypeId"
                        ></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="3">
                      <p class="el-form-item__label">{{ $t("m.supplier") }}</p>
                      <el-select
                        v-model="meterOne.spElectricitySupplierId"
                        disabled
                      >
                        <el-option
                          v-for="item in supplierList"
                          :key="item.spElectricitySupplierId"
                          :label="item.name"
                          :value="item.spElectricitySupplierId"
                        ></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="3">
                      <p class="el-form-item__label">
                        {{ $t("m.capacity") }} (kW)
                      </p>
                      <el-input
                        v-model="meterOne.meterCapacity"
                        type="number"
                        disabled
                      />
                    </el-col>
                    <el-col v-show="meterOne.spMeterTypeId != '4'" :span="3">
                      <p class="el-form-item__label">{{ $t("m.wholeSale") }}</p>
                      <!-- charger必须手动输入电价 -->
                      <el-select v-model="meterOne.wholeSaleFlag" disabled>
                        <el-option
                          v-for="item in wholesaleList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-col>
                  </div>
                </el-row>
                <el-row v-if="meterOne.wholeSaleFlag == '0'">
                  <el-row>
                    <el-col :span="4" :offset="2">
                      <p class="el-form-item__label">
                        {{
                          $t("m.tariffPeriod") + "(" + getMoneyUnit() + "/kWh)"
                        }}
                      </p>
                    </el-col>
                    <el-col :span="4" :offset="2">
                      <p class="el-form-item__label">{{ $t("m.timeRange") }}</p>
                    </el-col>
                  </el-row>
                  <el-row
                    v-for="(tariffOne, tariffIndex) in meterOne.tariffList"
                    :key="tariffIndex"
                    class="tariff-one"
                  >
                    <el-col :span="4" :offset="2">
                      <el-input v-model="tariffOne.price" disabled />
                    </el-col>
                    <el-col :span="4" :offset="2">
                      <el-time-select
                        v-model="tariffOne.startTime"
                        :picker-options="{
                          start: '00:00',
                          step: '01:00',
                          end: '23:00'
                        }"
                        disabled
                      >
                      </el-time-select>
                    </el-col>
                    <el-col :span="1" class="sign"><span>~</span></el-col>
                    <el-col :span="4">
                      <el-time-select
                        v-model="tariffOne.endTime"
                        :picker-options="{
                          start: limitEndTime(tariffOne.startTime),
                          step: '01:00',
                          end: '23:59'
                        }"
                        disabled
                      >
                      </el-time-select>
                    </el-col>
                  </el-row>
                </el-row>
              </el-row>
              <el-col :span="24">
                <el-form-item :label="$t('m.resampleRule')" prop="resampleRule">
                  <el-select v-model="form.resampleRule" disabled>
                    <el-option
                      v-for="item in resampleRuleList"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- load数据 -->
              <div v-if="siteTypeDetail.haveLoadFlag">
                <el-row
                  v-for="(loadOne, loadIndex) in form.loadList"
                  :key="loadIndex"
                  class="meter-one clearfix"
                >
                  <el-row :gutter="8" class="clearfix">
                    <el-col :span="2">
                      <p class="el-form-item__label">{{ $t("m.number") }}</p>
                      <el-input
                        disabled
                        class="meter-number-input"
                        :value="loadIndex + 1"
                      />
                    </el-col>
                    <el-col :span="5">
                      <p class="el-form-item__label">{{ $t("m.loadName") }}</p>
                      <el-input v-model="loadOne.assetName" disabled />
                    </el-col>
                    <el-col :span="5">
                      <p class="el-form-item__label">{{ $t("m.loadType") }}</p>
                      <el-select v-model="loadOne.loadType" disabled>
                        <el-option
                          v-for="item in loadTypeList"
                          :key="item"
                          :label="item"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="5">
                      <p class="el-form-item__label">{{ $t("m.meterName") }}</p>
                      <el-select v-model="loadOne.spMeterId" disabled>
                        <!-- 站点新增时，使用index做value传给后台;站点编辑时，使用spMeterId做value直接传给后台 -->
                        <el-option
                          v-for="item in form.meterList"
                          :key="item.spMeterId"
                          :label="item.meterName"
                          :value="item.spMeterId"
                        ></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="5">
                      <p class="el-form-item__label">{{ $t("m.loadModel") }}</p>
                      <el-select v-model="loadOne.spAlgoModelId" disabled>
                        <el-option
                          v-for="item in modelList"
                          :key="item.spAlgoModelId"
                          :label="item.algoModelName"
                          :value="item.spAlgoModelId"
                        ></el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </el-row>
              </div>
            </el-row>
            <!-- system -->
            <el-row v-if="operateMode.includes('system')">
              <el-col :span="10">
                <el-form-item :label="$t('m.systemName')" prop="systemName">
                  <el-input v-model="form.systemName" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="4">
                <el-form-item :label="$t('m.systemType')" prop="spSystemTypeId">
                  <el-select v-model="form.spSystemTypeId" disabled>
                    <el-option
                      v-for="item in systemTypeList"
                      :key="item.spSystemTypeId"
                      :label="item.systemTypeName"
                      :value="item.spSystemTypeId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item
                  :label="$t('m.meterName')"
                  prop="bindingMeterList"
                >
                  <el-select v-model="form.bindingMeterList" multiple disabled>
                    <el-option
                      v-for="item in siteMeterList"
                      :key="item.spMeterId"
                      :label="item.meterName"
                      :value="item.spMeterId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="4">
                <el-form-item
                  :label="$t('m.defaultExecutionMode')"
                  prop="defaultSystemModeTypeCode"
                >
                  <el-select v-model="form.defaultSystemModeTypeCode" disabled>
                    <el-option
                      v-for="item in executionModeList"
                      :key="item.modeType"
                      :label="item.modeName"
                      :value="item.modeType"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item
                  :label="$t('m.pcsPower') + ' (kW)'"
                  prop="pcsPower"
                >
                  <el-input v-model="form.pcsPower" type="number" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="4">
                <el-form-item
                  :label="$t('m.IOTAccountId')"
                  prop="spIotPlatformId"
                >
                  <el-select v-model="form.spIotPlatformId" disabled>
                    <el-option
                      v-for="item in IOTAccountIDList"
                      :key="item.spIotPlatformId"
                      :label="item.iotName"
                      :value="item.spIotPlatformId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item
                  :label="$t('m.IOTDeviceIdForDataQuer')"
                  prop="subscribeSpIotDeviceId"
                >
                  <el-select v-model="form.subscribeSpIotDeviceId" disabled>
                    <el-option
                      v-for="item in IOTDeviceList"
                      :key="item.spIotDeviceId"
                      :label="item.iotDeviceName"
                      :value="item.spIotDeviceId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="4">
                <el-form-item
                  :label="$t('m.IOTDeviceIdForCommandIssuance')"
                  prop="gatewaySpIotDeviceId"
                >
                  <el-select v-model="form.gatewaySpIotDeviceId" disabled>
                    <el-option
                      v-for="item in IOTDeviceList"
                      :key="item.spIotDeviceId"
                      :label="item.iotDeviceName"
                      :value="item.spIotDeviceId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                v-if="systemTypeHasBess()"
                :span="10"
                :offset="4"
                :pull="4"
              >
                <el-form-item
                  key="haveAncillaryServiceFlag"
                  :label="$t('m.ancillaryService')"
                  prop="haveAncillaryServiceFlag"
                >
                  <el-select v-model="form.haveAncillaryServiceFlag" disabled>
                    <el-option
                      v-for="item in ancillaryServiceList"
                      :key="item.haveAncillaryServiceFlag"
                      :label="item.name"
                      :value="item.haveAncillaryServiceFlag"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col v-if="form.haveAncillaryServiceFlag == '1'" :span="10">
                <el-form-item
                  key="aggregator"
                  :label="$t('m.aggregator')"
                  prop="spAggregatorPlatformId"
                >
                  <el-select v-model="form.spAggregatorPlatformId" disabled>
                    <el-option
                      v-for="item in aggregatorList"
                      :key="item.spAggregatorPlatformId"
                      :label="item.aggregatorName"
                      :value="item.spAggregatorPlatformId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col v-if="systemTypeHasCharger()" :span="10">
                <el-form-item :label="$t('m.cpo')" prop="spCpoPlatformId">
                  <el-select v-model="form.spCpoPlatformId" disabled>
                    <el-option
                      v-for="item in CPOPlatFormList"
                      :key="item.spCpoPlatformId"
                      :label="item.cpoName"
                      :value="item.spCpoPlatformId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- PV -->
            <div v-if="operateMode.includes('asset-pv')">
              <h4>{{ $t("m.assetPVAdd") }}</h4>
              <el-row>
                <el-col :span="10">
                  <el-form-item :label="$t('m.assetName')" prop="assetName">
                    <el-input v-model="form.assetName" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="4">
                  <el-form-item
                    :label="$t('m.equipmentManufacturer')"
                    prop="manufacturer"
                  >
                    <el-input v-model="form.manufacturer" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item
                    :label="$t('m.productModel')"
                    prop="productModel"
                  >
                    <el-input v-model="form.productModel" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="4">
                  <el-form-item
                    :label="$t('m.maximumRatedPower') + ' (kW)'"
                    prop="maximumRatedPower"
                  >
                    <el-input
                      v-model="form.maximumRatedPower"
                      type="number"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item
                    :label="$t('m.DCModulePower') + ' (kW)'"
                    prop="DCModulePower"
                    type="number"
                  >
                    <el-input v-model="form.DCModulePower" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="4">
                  <el-form-item
                    :label="$t('m.solarPanelsNumber')"
                    prop="solarPanelsNumber"
                    type="number"
                  >
                    <el-input v-model="form.solarPanelsNumber" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item
                    :label="$t('m.solarPanelsRatedPower') + ' (kW)'"
                    prop="solarPanelsRatedPower"
                  >
                    <el-input v-model="form.solarPanelsRatedPower" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="4">
                  <el-form-item
                    :label="$t('m.firstYearDegradationRate') + ' (%)'"
                    prop="firstYearDegradationRate"
                  >
                    <el-input
                      v-model="form.firstYearDegradationRate"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item
                    :label="$t('m.linearDegradationRate') + ' (%)'"
                    prop="linearDegradationRate"
                  >
                    <el-input v-model="form.linearDegradationRate" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="4">
                  <el-form-item
                    :label="$t('m.warrantyPeriod')"
                    prop="warrantyPeriod"
                  >
                    <el-input v-model="form.warrantyPeriod" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item :label="$t('m.model')" prop="model">
                    <el-select v-model="form.spAlgoModelId" disabled>
                      <el-option
                        v-for="item in modelList"
                        :key="item.spAlgoModelId"
                        :label="item.algoModelName"
                        :value="item.spAlgoModelId"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="4">
                  <el-form-item
                    :label="$t('m.IOTDeviceIdForDataQuer')"
                    prop="IOTDeviceIdForDataQuer"
                  >
                    <el-select v-model="form.IOTDeviceIdForDataQuer" disabled>
                      <el-option
                        v-for="item in IOTDeviceList"
                        :key="item.spIotDeviceId"
                        :label="item.iotDeviceName"
                        :value="item.spIotDeviceId"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <!-- BESS -->
            <div v-if="operateMode.includes('asset-bess')">
              <h4>{{ $t("m.BESS") }}</h4>
              <el-row>
                <el-col :span="10">
                  <el-form-item :label="$t('m.assetName')" prop="assetName">
                    <el-input v-model="form.assetName" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="4">
                  <el-form-item
                    :label="$t('m.equipmentManufacturer')"
                    prop="manufacturer"
                  >
                    <el-input v-model="form.manufacturer" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item
                    :label="$t('m.productModel')"
                    prop="productModel"
                  >
                    <el-input v-model="form.productModel" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="4">
                  <el-form-item
                    :label="$t('m.maximumChargingRatedPower') + ' (kW)'"
                    prop="maximumChargingRatedPower"
                  >
                    <el-input
                      v-model="form.maximumChargingRatedPower"
                      type="number"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item
                    :label="$t('m.maximumDischargingRatedPower') + ' (kW)'"
                    prop="maximumDischargingRatedPower"
                  >
                    <el-input
                      v-model="form.maximumDischargingRatedPower"
                      type="number"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="4">
                  <el-form-item
                    :label="$t('m.DCModulePower') + ' (kW)'"
                    prop="DCModulePower"
                  >
                    <el-input
                      v-model="form.DCModulePower"
                      type="number"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item
                    :label="$t('m.batteryCapacity') + ' (kW)'"
                    prop="batteryCapacity"
                  >
                    <el-input
                      v-model="form.batteryCapacity"
                      type="number"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="4">
                  <el-form-item
                    :label="$t('m.warrantyPeriod') + ' (yrs)'"
                    prop="warrantyPeriod"
                  >
                    <el-input
                      v-model="form.warrantyPeriod"
                      type="number"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item
                    :label="$t('m.warrantyCyclesNumber')"
                    prop="warrantyCyclesNumber"
                  >
                    <el-input
                      v-model="form.warrantyCyclesNumber"
                      type="number"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="4">
                  <el-form-item
                    :label="$t('m.maxDailyCycle')"
                    prop="maxDailyCycle"
                  >
                    <el-input
                      v-model="form.maxDailyCycle"
                      type="number"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item
                    :label="$t('m.coolingTime') + ' (s)'"
                    prop="coolingTime"
                  >
                    <el-input
                      v-model="form.coolingTime"
                      type="number"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="4">
                  <el-form-item
                    :label="$t('m.operatingTemperature') + ' (℃)'"
                    prop="minOperatingTemperature"
                  >
                    <el-input
                      v-model="form.minOperatingTemperature"
                      class="temperature-input"
                      type="number"
                      disabled
                    />
                    <span class="sign">~</span>
                    <el-input
                      v-model="form.maxOperatingTemperature"
                      class="temperature-input"
                      type="number"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item :label="$t('m.beginSoc')" prop="beginSoc">
                    <el-input v-model="form.beginSoc" type="number" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="4">
                  <el-form-item :label="$t('m.endSoc')" prop="endSoc">
                    <el-input v-model="form.endSoc" type="number" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item :label="$t('m.model')" prop="spAlgoModelId">
                    <el-select v-model="form.spAlgoModelId" disabled>
                      <el-option
                        v-for="item in modelList"
                        :key="item.spAlgoModelId"
                        :label="item.algoModelName"
                        :value="item.spAlgoModelId"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="4">
                  <el-form-item :label="$t('m.mdr')" prop="mdr">
                    <el-input v-model.number="form.mdr" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    :label="$t('m.IOTDeviceIdForDataQuer')"
                    prop="IOTDeviceIdForDataQuer"
                  >
                    <el-select v-model="form.IOTDeviceIdForDataQuer" disabled>
                      <el-option
                        v-for="item in IOTDeviceList"
                        :key="item.spIotDeviceId"
                        :label="item.iotDeviceName"
                        :value="item.spIotDeviceId"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <!-- Charging -->
            <div v-if="operateMode.includes('asset-charging')">
              <h4>Charging System</h4>
              <el-row>
                <el-col :span="10">
                  <el-form-item :label="$t('m.assetName')" prop="assetName">
                    <el-input v-model="form.assetName" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="4">
                  <el-form-item
                    :label="$t('m.equipmentManufacturer')"
                    prop="manufacturer"
                  >
                    <el-input v-model="form.manufacturer" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item
                    :label="$t('m.productModel')"
                    prop="productModel"
                  >
                    <el-input v-model="form.productModel" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="4">
                  <el-form-item
                    :label="$t('m.DCModulePower') + ' (kW)'"
                    prop="DCModulePower"
                  >
                    <el-input v-model="form.DCModulePower" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    :label="$t('m.IOTDeviceIdForDataQuer')"
                    prop="IOTDeviceIdForDataQuer"
                  >
                    <el-select v-model="form.IOTDeviceIdForDataQuer" disabled>
                      <el-option
                        v-for="item in IOTDeviceList"
                        :key="item.spIotDeviceId"
                        :label="item.iotDeviceName"
                        :value="item.spIotDeviceId"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- charger list -->
                <el-row
                  v-for="(chargerOne, chargerIndex) in form.chargerList"
                  :key="chargerIndex"
                  class="meter-one clearfix"
                >
                  <el-row>
                    <div>
                      <el-col :span="5">
                        <p class="el-form-item__label">
                          {{ $t("m.chargerName") }}
                        </p>
                        <el-input v-model="chargerOne.chargerName" disabled />
                      </el-col>
                      <el-col :span="5" :offset="1">
                        <p class="el-form-item__label">
                          {{ $t("m.maximumRatedPower") + " (kW)" }}
                        </p>
                        <el-input
                          v-model="chargerOne.maximumRatedPower"
                          disabled
                        />
                      </el-col>
                      <el-col :span="5" :offset="1">
                        <p class="el-form-item__label">
                          {{ $t("m.charger") + " " + $t("m.thirdDeviceId") }}
                        </p>
                        <el-input v-model="chargerOne.code" disabled />
                      </el-col>
                      <el-col :span="5" :offset="1">
                        <p class="el-form-item__label">
                          {{ $t("m.IOTDeviceIdForDataQuer") }}
                        </p>
                        <el-select
                          v-model="chargerOne.IOTDeviceIdForDataQuer"
                          disabled
                        >
                          <el-option
                            v-for="item in IOTDeviceList"
                            :key="item.spIotDeviceId"
                            :label="item.iotDeviceName"
                            :value="item.spIotDeviceId"
                          ></el-option>
                        </el-select>
                      </el-col>
                    </div>
                  </el-row>
                  <el-row>
                    <el-row>
                      <el-col :span="6" :offset="1">
                        <p class="el-form-item__label">
                          {{ $t("m.connectorName") }}
                        </p>
                      </el-col>
                      <el-col :span="6" :offset="2">
                        <p class="el-form-item__label">
                          {{ $t("m.connector") + " " + $t("m.thirdDeviceId") }}
                        </p>
                      </el-col>
                      <el-col :span="6" :offset="2">
                        <p class="el-form-item__label">
                          {{ $t("m.maxChargingPower") }}（kW）
                        </p>
                      </el-col>
                    </el-row>
                    <el-row
                      v-for="(connectorOne,
                      connectorIndex) in chargerOne.connectorList"
                      :key="connectorIndex"
                      class="tariff-one"
                    >
                      <el-col :span="6" :offset="1">
                        <el-input
                          v-model="connectorOne.connectorName"
                          disabled
                        />
                      </el-col>
                      <el-col :span="6" :offset="2">
                        <el-input
                          v-model="connectorOne.connectorCode"
                          disabled
                        />
                      </el-col>
                      <el-col :span="6" :offset="2">
                        <el-input
                          v-model="connectorOne.maxChargingPower"
                          disabled
                        />
                      </el-col>
                    </el-row>
                  </el-row>
                </el-row>
              </el-row>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageMy from "./my.vue";
import NavHeader from "../components/header.vue";
import PageDashboard from "./dashboard.vue";
import timezoneData from "../assets/data/timezone";
// 各资产充电/放电图的颜色
const chartColorObj = {
  pv: {
    actual: ["#FFB200", "#FFC133", "#FFD166", "#FFE099", "#FFF0CC"],
    forecast: ["#FFE8B2", "#FFECC1", "#FFF1D1", "#FFE099", "#FFFBF0"]
  },
  charging: {
    actual: [
      "#66D1CB",
      "#00B2A9",
      "#66C9EC",
      "#00A5DF",
      "#FFD166",
      "#FFB202",
      "#C2C2C2",
      "#999999"
    ],
    forecast: ["#D7F0EE", "#C1E9F7", "#D1EFF9", "#E0F4FB", "#F0FAFE"]
  },
  batteryCharging: {
    actual: ["#00A5DF", "#33B7E5", "#66C9EC", "#99DBF2", "#CCEDF9"],
    forecast: ["#B2E4F5", "#C1E9F7", "#D1EFF9", "#E0F4FB", "#F0FAFE"]
  },
  batteryDischarging: {
    actual: ["#FF9500", "#FFB200", "#FFC133", "#FFD166", "#FFE099"],
    forecast: ["#FFDFB2", "#FFE8B2", "#FFECC1", "#FFF1D1", "#FFE099"]
  },
  load: {
    actual: ["#999999"],
    forecast: ["#EEEEEE"]
  },
  tariff: {
    import: "#00A5DF",
    export: "#FFB200",
    charger: "#00B2A9",
    mpan: "#999999",
    volume: "#00A5DF"
  }
};
const weeklyIdObj = {
  Mon: 2,
  Tue: 3,
  Wed: 4,
  Thu: 5,
  Fri: 6,
  Sat: 7,
  Sun: 1
};
const weeklyTextObj = {
  2: "Mon",
  3: "Tue",
  4: "Wed",
  5: "Thu",
  6: "Fri",
  7: "Sat",
  1: "Sun"
};
const judgeSystemModeInterval = 60000; // ms
export default {
  data() {
    return {
      timeStartList: [],
      timeEndList: [],
      eventFilterBoxShow: false,
      judgeSystemModeTimer: null,
      selectedPlanIsDelete: false,
      selectedSystemPlanDetail: {},
      modalCalendarHeaderMonth: "",
      planModalTitleObj: {
        add: "Create Plan",
        "edit-one": "Edit Daily Plan",
        "edit-all": "Edit Recurring Plan"
      },
      selectedTopNav: "1",
      eventList: [],
      modalselectedDataDay: "",
      systemList: [],
      eventTypeList: [],
      planModalShow: false,
      planForm: {},
      formRules: {},
      planModeList: [],
      planFormSelectedSiteDetail: {},
      planRepetitionList: [
        {
          id: "monthly",
          name: "monthly"
        },
        {
          id: "weekly",
          name: "weekly"
        }
      ],
      descList: [],
      planFormRule: {
        site: [
          {
            required: true,
            message: this.$t("m.site") + this.$t("m.emptyTip"),
            trigger: "blur"
          }
        ],
        system: {
          required: true,
          message: this.$t("m.system") + this.$t("m.emptyTip"),
          trigger: "change"
        },
        startDate: {
          required: true,
          message: this.$t("m.startDate") + this.$t("m.emptyTip"),
          trigger: "blur"
        },
        mode: {
          required: true,
          message: this.$t("m.mode") + this.$t("m.emptyTip"),
          trigger: "change"
        },
        repetition: {
          required: true,
          message: this.$t("m.repetition") + this.$t("m.emptyTip"),
          trigger: "change"
        }
      },
      operateMode: "site-add",
      siteTypeDetail: {},
      dailyDay: {
        startTime: "",
        endTime: "",
        period: 2
      },
      demoEvents: {
        "2024-10-07": 2,
        "2024-10-08": 1
      },
      allModeTypeObj: {},
      calendarEventsList: {},
      modalCalendarEventsList: {
        "2024-10-07": [
          {
            title: "Energy Saving",
            mode: 1
          },
          {
            title: "Ultra Fast Charging",
            mode: 2
          }
        ],
        "2024-10-08": [
          {
            title: "Ancillary Service",
            mode: 3
          }
        ]
      },
      timeArr: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24"
      ],
      sitePlanList: [],
      planModeClass: {
        10: "ultraFastCharging",
        20: "AncillaryService",
        30: "energySaving"
      },
      chargeDischargeDataIsNormal: true,
      SOCDataIsNormal: true,
      SOCSelectList: [],
      selectedSOCId: "",
      SOCData: [],
      importTariffList: [],
      exportTariffList: [],
      chargingTariffList: [],
      MPANList: [],
      selectedMPANId: "",
      MPANPriceList: [],
      MPANTbKey: "",
      MPANVolumeList: [],
      data: {
        period: "12:00-13:00",
        unit: "kWh",
        consumption: {
          total: 24
        }
      },
      chargingTopData: {
        charge: "",
        chargeList: []
      },
      chargingRecordModalShow: false,
      chargingRecordList: [],
      connectorStatusChangeObj: {
        occupied: "Charging",
        preparing: "Charging",
        charging: "Charging",
        suspended_evse: "Charging",
        finishing: "Charging",
        available: "Available",
        suspended_ev: "Available",
        reserved: "Available",
        unavailable: "Faulted",
        faulted: "Faulted",
        closed: "Closed"
      },
      connectorStatusObj: {
        Charging: "Charging",
        Available: "Available",
        Closed: "Closed",
        Faulted: "Faulted"
      },
      chartsGunData: null,
      gunDataSeries: [],
      gunData: [],
      gunDataLegend: [],
      connectorList: [],
      firstHourTimestamps: 0,
      futureDay: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now(); // 8.64e7 毫秒数代表一天;
        }
      },
      treeNodes: [],
      treeSwitchers: [],
      tooltipShowObj: {
        chargeAndDischarge: false,
        pv: false,
        loadAndGrid: false,
        date: false
      },
      batterySeries: {},
      batteryLegend: {},
      chargingSeries: {},
      seriesObj: {},
      legendObj: {},
      pvSeries: {},
      pvLegend: {},
      loadSeries: {},
      loadLegend: {},
      chargingLegend: {},
      weatherData: {
        temp: [],
        uvi: [],
        clouds: []
      },
      weatherCity: {
        1: "Osaka",
        2: "Shanghai",
        3: "London"
      },
      replaceFields: {
        children: "children",
        title: "name",
        key: "id"
      },
      defaultSelectedKeys: [],
      assetSearchValue: "",
      selectedDeleteAsset: {},
      selectedDeleteMode: "site",
      // 新增/编辑页面类型和操作模式
      assetOperateMode: "site-add", // add-site;add-pv;add-es;add-load;edit-site;edit-pv;edit-es;edit-load
      selectedViewDay: "1",
      selectedSiteView: "1",
      siteViewList: [
        {
          id: "1",
          value: this.$t("m.modes")
        },
        {
          id: "2",
          value: this.$t("m.events")
        }
      ],
      realTimeDataShow: false,
      ffrParamsInfo: {
        date: "2022-01-01",
        timeRange: "07:00-09:00",
        tbDeviceId: "f38e8230-8792-11eb-9b87-c72a2022df32"
      },
      paramIsSave: false,
      realTime: "",
      realDate: "",
      currentMinute: 0,
      step: 0,
      countryAssetNumListShow: false,
      createAssetModalShow: false,
      countryAssetNumObj: {},
      // 自定义参数
      paramModalShow: false,
      paramListShow: false,
      selectedParamList: [""],
      selectedScheduleDate: "2022-01-11",
      scheduleModalShow: false,
      calendarList: [
        // {
        //   date: "2022/3/18",
        //   className: "special",
        // },
      ],

      statusObj: {
        10: "未开始",
        20: "进行中",
        30: "已完成"
      },
      alarmModalShow: false,
      workOrderModalShow: false,
      levelObj: {
        1: "general alarm",
        2: "stop system",
        3: "stop system and site visit ASAP"
      },
      levelClassObj: {
        1: "g",
        2: "s",
        3: "ss"
      },
      levelBgcObj: {
        1: "#FFA63F",
        2: "#FF0017",
        3: "#FF0017"
      },
      levelSolutionObj: {
        1: "Need a system reset",
        2: "inform BYD",
        3: "inform BYD"
      },
      historyAlarmList: [],
      selectedAlarmDate: "",
      mapFullScreen: false,
      alarmCycle: "daily",
      workOrderCycle: "daily",
      mapData: [
        {
          lat: 37.409265,
          lng: 118.502735,
          oilStationName: "test",
          address: "test"
        }
      ],
      selectedOperation: 1,
      charts: null,
      chartsSOC: null,
      chartTariff: null,
      tariffOption: {},
      forecastSOCOption: {},
      realtimeSOCOption: {},
      chartsRealTime: null,
      realTimeNormalLegend: [],
      realTimeNormalSeries: [],
      predictDataCount: 0,
      predictSeries: [],
      predictOption: [],
      predictLegend: [],
      predictMax: 100,
      predictCharts: null,
      optionRealTime: null,
      alarmChart: null,
      selectedCountry: "0",
      countryList: [],
      alarmList: [],
      selectedAsset: "Asset01",
      assetList: [],
      option: null,
      mapCenter: {
        lat: 35,
        lng: 105
      },
      mapZoom: 1,
      map: null,
      mark: null,
      icon: null,
      markers: [],
      infowindow: [],
      // 所有合同列表
      allContractList: [],
      // 资产合同列表
      contractList: [],
      // 选中的合同
      selectedContract: {},
      // 选中的资产信息
      selectedAssetObj: {},
      topParamData: {
        BESS: {},
        SOLAR: {},
        LOAD: {},
        METER: {}
      },
      topPVLoadData: {
        load: 0,
        solar: 0
      },
      topChargeData: {
        charging: 0,
        load: 0,
        batteryCharging: 0,
        batteryDischarging: 0,
        solar: 0
      },
      // 站点列表
      siteList: [],
      // 选中的站点ID
      selectedSite: "",
      // 选中的站点信息
      selectedSiteObj: {},
      // contactModalShow: false,
      email: "",
      remark: "",
      timer: null,
      pageParamMode: "1",
      assetStatusTimer: null,
      planList: [],
      planTypeList: [],
      assetStatusFlag: true,
      startIndex: 0,
      endIndex: 24,
      chartsData: {
        Volume: {
          "Bess from grid": {},
          chargeTotal: "",
          dischargeTotal: ""
        },
        estimated_generation: {},
        estimated_load: {},
        estimated_saving: {},
        SoC: [],
        "SoC end in kWh": "",
        "SoC start in kWh": "",
        "charge in SoC": [],
        "charge in kw": [],
        charge_in_kwh: [],
        "daily cycles": "",
        "daily storage value": "",
        "discharge in SoC": [],
        "discharge in kw": [],
        discharge_in_kwh: [],
        "dsr list": [],
        granularity: 0,
        "outage list": [
          {
            end_index: 0,
            soc: 0,
            start_index: 0
          }
        ],
        price_list: []
      },
      selectedAssetPrice: "",
      markArea: {},
      series: [],
      pageShow: false,
      chartsUnitObj: {},
      chartsColorObj: {
        SOC: "#27D3D5"
      },
      paramViewType: "40",
      deleteModalShow: false,
      selectedAssetId: "",
      selectedSiteId: "",
      chartResizeTimer: null,
      assetTypeMode: {
        20: "edit-pv",
        10: "edit-es",
        30: "edit-load"
      },
      assetStatus: {},
      assetPower: {},
      assetStatusTime: {},
      nextPlanName: {},
      nextPlanTime: {},
      allAssetPlan: {},
      selectedDataDay: "",
      axisLableColor: "#7c8d9d",
      changeSiteTimer: "",
      assetIconObj: {
        10: require("../assets/img/icon-asset-bess.png"), // 储能
        20: require("../assets/img/icon-asset-pv.png"), // 光伏
        30: require("../assets/img/icon-asset-load.png"), // 负荷
        40: require("../assets/img/icon-asset-charger.png") // 充电集
      },
      assetTypeClass: {
        10: "battery",
        20: "pv",
        30: "load",
        40: "charger"
      },
      socketToken: "",
      singleWs: "",
      wsParams: "",
      wsHistoryParams: "",
      actualData: {
        pv: [],
        load: []
      },
      forecastData: {
        pv: [],
        load: [],
        availableForEv: []
      },
      assetActualForecastData: [],
      pvMinList: [],
      pvMaxList: [],
      pvList: [],
      batteryChargeList: [],
      batteryMinChargeList: [],
      batteryMaxChargeList: [],
      batteryDischargeList: [],
      batteryMinDischargeList: [],
      batteryMaxDischargeList: [],
      ppv1List: [],
      ppv2List: [],
      pvPowerList: [],
      batteryPowerList: [],
      loadPowerList: [],
      loadMinList: [],
      loadMaxList: [],
      minDataList: {
        load: [],
        pv: [],
        charge: [],
        discharge: []
      },
      maxDataList: {
        load: [],
        pv: [],
        charge: [],
        discharge: []
      },
      socList: [],
      prevSOCList: [],
      params: {
        power: "",
        startTime: "",
        endTime: "",
        timezone: "",
        tbDeviceId: "65c70230-8795-11eb-9b87-c72a2022df32"
      },
      selectedLevel: "site",
      selectedAssetInfo: {},
      selectedSiteInfo: {
        bindingBillTypeCodeList: []
      },
      dispatchInChart: null,
      dispatchOutChart: null,
      powerGenerationChart: null,
      powerConsumptionChart: null,
      dispatchInChartOption: {},
      dispatchOutChartOption: {},
      powerGenerationChartOption: {},
      powerConsumptionChartOption: {},
      getRealDataCount: 0,
      planIsSaved: false,
      eventListFilter: {
        size: 10,
        currentPage: 1,
        total: 0,
        system: "",
        eventType: ""
      },
      planOperateMode: "add", // add: add plan;edit-one: edit the plan;edit-all: edit all plans
      selectedEditPlanDetail: {},
      editAssetModalShow: false,
      siteTypeList: [],
      regionList: [],
      timezoneList: [],
      bindingBillTypeCodeList: [],
      resampleRuleList: [],
      wholesaleList: [
        {
          id: "1",
          name: "YES"
        },
        {
          id: "0",
          name: "NO"
        }
      ],
      systemTypeList: [],
      executionModeList: [],
      IOTAccountIDList: [],
      IOTDeviceList: [],
      ancillaryServiceList: [],
      aggregatorList: [],
      CPOPlatFormList: [],
      modelList: [],
      form: {},
      title: "title",
      billTypeList: [],
      meterTypeList: [],
      supplierList: [],
      loadAssetTypeDetail: {},
      selectedSystemTypeDetail: {},
      viewInfoMode: "site",
      siteMeterList: [],
      eventStateTextObj: {
        10: "Completed",
        20: "Planned",
        30: "Fail",
        40: "Charging"
      },
      eventsTopData: {
        total: 0,
        ultraFastCharging: 0,
        ancillaryService: 0
      },
      eventsTypeTextObj: {
        10: "Charging Event",
        20: "Ancillary Service"
      },
      eventsTypeOptions: [
        {
          id: 10,
          name: "Ultra Fast Charging"
        },
        {
          id: 20,
          name: "Ancillary Service"
        }
      ],
      eventsDescTextObj: {
        10: "FFR",
        20: "AFFR"
      },
      calendarShow: true,
      prevBtn: "",
      todayBtn: "",
      nextBtn: "",
      calendarHeader: "",
      calendarHeaderTitle: "",
      calendarHeaderMonth: "",
      onlineDay: ""
    };
  },
  watch: {
    "planForm.planList"(now) {
      console.log(now, "plan list");
      console.log(
        timezoneData[this.selectedSiteInfo.timeZoneId][now],
        "is DST or ST"
      );
      now.forEach(item => {
        console.log(item, "item");
      });
    },
    "planForm.startTime"(now) {
      console.log(now, "startTime");
      this.planForm.endTime = "";
      this.timeEndList = this.timeEndList.filter(item => {
        return (
          new Date("2025-01-01 " + item).getTime() >
          new Date("2025-01-01 " + now).getTime()
        );
      });
    },
    "planForm.startDate"(now, prev) {
      console.log(now, "startDate");
      console.log(this.selectedSiteInfo.timeZoneId, "timeZoneId");
      console.log(
        timezoneData[this.selectedSiteInfo.timeZoneId][now],
        "is DST or ST"
      );
      if (
        timezoneData[this.selectedSiteInfo.timeZoneId] &&
        timezoneData[this.selectedSiteInfo.timeZoneId][now]
      ) {
        // 有夏令时冬令时变化
        if (timezoneData[this.selectedSiteInfo.timeZoneId][prev]) {
          // 上一个选择日期有夏令时冬令时变化
          if (
            timezoneData[this.selectedSiteInfo.timeZoneId][prev].type !=
            timezoneData[this.selectedSiteInfo.timeZoneId][now].type
          ) {
            // 新选择的日期跟上一个选择日期所对应的夏令时冬令时切换不同，则需要重新获取时间列表
            this.handleTimeList(
              timezoneData[this.selectedSiteInfo.timeZoneId][now]
            );
          }
        } else {
          this.handleTimeList(
            timezoneData[this.selectedSiteInfo.timeZoneId][now]
          );
        }
      } else {
        if (timezoneData[this.selectedSiteInfo.timeZoneId][prev]) {
          this.handleTimeList();
        }
      }
    },
    "planForm.site"(now) {
      this.planFormSelectedSiteDetail = this.siteList.find(item => {
        return item.spSiteId == now;
      });
    },
    "planForm.repetition"(now) {
      if (now == "weekly") {
        this.planFormRule.weekly = [
          {
            required: true,
            message: this.$t("m.weekly") + this.$t("m.emptyTip"),
            trigger: "blur"
          }
        ];
      } else {
        delete this.planFormRule.weekly;
      }
    },
    selectedTopNav(now) {
      console.log(now, "selectedTopNav");
      // top nav切换后重新选择到站点
      this.selectedLevel = "site";
      this.selectedAssetObj = this.siteList.find(
        item => item.spSiteId == this.selectedSiteInfo.spSiteId
      );
      this.systemList = this.selectedAssetObj.systemList;
      this.calendarShow = false;
      this.calendarShow = true;
      if (now == "1" || now == "2") {
        this.$nextTick(() => {
          this.getCurrentTime();
        });
      }
    },
    selectedDataDay(now) {
      console.log(now, "selected data day ???");
      if (timezoneData[this.selectedSiteInfo.timeZoneId]) {
        // 存在对应的时区数据
        const timezoneDataDetail =
          timezoneData[this.selectedSiteInfo.timeZoneId][now];
        let timeStr = "";
        this.timeArr = [];
        for (let i = 0; i < 25; i++) {
          // 冬令时转夏令时当天，跳过某个小时
          if (
            timezoneDataDetail &&
            timezoneDataDetail.type == "DST" &&
            i == timezoneDataDetail.num - 1
          ) {
            continue;
          }
          timeStr = i < 10 ? "0" + i : i;
          this.timeArr.push(timeStr);
          // 夏令时转冬令时当天，重复某个小时
          if (
            timezoneDataDetail &&
            timezoneDataDetail.type == "ST" &&
            i == timezoneDataDetail.num
          ) {
            this.timeArr.push(timeStr);
          }
        }
      }
    }
  },
  components: {
    PageMy,
    NavHeader,
    PageDashboard
  },
  props: ["contactModalShow"],
  mounted() {
    this.setCalendarHeader();
  },
  destroyed() {
    this.singleWs && this.singleWs.close();
    this.timer && clearInterval(this.timer);
    this.assetStatusTimer && clearInterval(this.assetStatusTimer);
  },
  created() {
    this.futureDay = (Date.now() + 86400000 + "").slice(0, 10);
    this.chartsUnitObj[this.$t("m.globalRadiation")] = "Wh/㎡";
    this.chartsUnitObj[this.$t("m.weatherTemperature")] = "℃";
    this.chartsUnitObj[this.$t("m.cloud")] = "";
    this.selectedDataDay = this.$dayjs(Date.now()).format("YYYY-MM-DD");
    this.getSiteList();
  },
  methods: {
    handleTimeList(
      timeObj = {
        type: "",
        time: "",
        num: ""
      }
    ) {
      // timeObj: { time: 02:00, type: "DST", num: 2 }
      // 开始夏令时，需要跳过上一小时，00:59 -> 02:00，数组中没有 01:00
      // timeObj: { time: 03:00, type: "ST", num: 3 }
      // 开始冬令时，需要重复这一小时，03:59 -> 03:00，数组中有两个 03:00
      this.timeStartList = [];
      this.timeEndList = [];
      let str = "";
      let hasRepeat = false;
      for (let i = 0; i < 25; i++) {
        if (i < 10) {
          str = "0" + i + ":00";
        } else {
          str = i + ":00";
        }
        if (timeObj.type == "DST" && i == timeObj.num - 1) {
          continue;
        }
        if (timeObj.type == "ST" && i == timeObj.num) {
          this.timeStartList.push({
            time: str,
            value: str + " isFirst"
          });
          this.timeEndList.push({
            time: str,
            value: str + " isFirst"
          });
          hasRepeat = true;
        }
        if (hasRepeat) {
          // 有重复的时间
          this.timeStartList.push({
            time: str,
            value: str + " isSecond"
          });
          this.timeEndList.push({
            time: str,
            value: str + " isSecond"
          });
          hasRepeat = false;
        } else {
          this.timeStartList.push({
            time: str,
            value: str
          });
          this.timeEndList.push({
            time: str,
            value: str
          });
        }
      }
      if (this.isPlanEdit()) {
        this.planForm.startTime = "";
        this.planForm.endTime = "";
      } else {
        this.planForm.planList.forEach(item => {
          item.startTime = "";
          item.endTime = "";
        });
      }
    },
    siteHaveBESS() {
      return (
        this.selectedAssetObj.batteryList &&
        this.selectedAssetObj.batteryList.length
      );
    },
    // 显示当前计划的模式和时间段
    handleEventDetailShow(item) {
      if (item.spSystemModeType == "10") {
        return (
          this.eventsTypeTextObj[item.spSystemModeType] +
          " (" +
          item.timeStart +
          "-" +
          item.timeEnd +
          ")"
        );
      } else {
        // AncillaryService需要展示desc
        return (
          this.eventsTypeTextObj[item.spSystemModeType] +
          " - " +
          this.eventsDescTextObj[item.spSystemModeSonType] +
          " (" +
          item.timeStart +
          "-" +
          item.timeEnd +
          ")"
        );
      }
    },
    // 货币的单位
    getMoneyUnit() {
      return this.selectedSiteInfo.siteUnit || "";
    },
    reserveEventFilterBoxShow() {
      this.eventFilterBoxShow = !this.eventFilterBoxShow;
    },
    changeEventFilterBoxShow(val) {
      this.eventFilterBoxShow = val;
    },
    resetEventFilter() {
      this.eventListFilter.system = "";
      this.eventListFilter.eventType = "";
      this.getEventList();
      this.changeEventFilterBoxShow(false);
    },
    handleFilterClick() {
      this.getEventList();
      this.changeEventFilterBoxShow(false);
    },
    // 数据为空时提示没有数据
    handleDataEmptyShow(data) {
      return data ? Number(Number(data).toFixed(2)).toLocaleString() : 0;
    },
    // Dashboard没有未来日期的数据，同时禁止选择站点/系统的上线时间之前的日期
    futureTimeLimitSelect(date) {
      return (
        (this.selectedTopNav == "2" &&
          new Date(date + " 00:00:00").getTime() > Date.now()) ||
        new Date(date + " 00:00:00").getTime() <
          new Date(this.selectedAssetObj.onlineDay + " 00:00:00").getTime()
      );
    },
    judgeTreeDisabled() {
      return (
        this.selectedLevel == "site" &&
        (this.selectedTopNav == "1" || this.selectedTopNav == "3")
      );
    },
    // 判断当前时间是否到计划时间
    isFutureTime(time) {
      return false;
    },
    hideEditAssetModal() {
      this.editAssetModalShow = false;
    },
    async showAssetDetailModal(info, viewInfoMode, operateMode) {
      this.viewInfoMode = viewInfoMode;
      this.operateMode = operateMode;
      if (viewInfoMode == "site") {
        const [
          resSiteDetail,
          resSiteTypeList,
          resCountryList,
          resResampleRuleList,
          resLoadTypeList,
          resBillTypeList
        ] = await Promise.all([
          this.$http.get("/base/site/info/" + info.spSiteId),
          this.$http.get("/base/siteType/selectList"),
          this.$http.get("/base/country/selectList"),
          this.$http.get("/base/tempConstant/resampleRuleSelectList"),
          this.$http.get("/base/tempConstant/loadTypeSelectList"),
          this.$http.get("/base/site/billTypeList")
        ]);
        this.form = { ...resSiteDetail.data };
        let loadParam = "";
        this.form.loadList.forEach(item => {
          for (loadParam in item.assetParams) {
            item[loadParam] = item.assetParams[loadParam];
          }
        });
        this.form.meterList.forEach(item => {
          item.wholeSaleFlag = item.wholeSaleFlag + "";
          // 如果没有tariffList，则添加一个空数组
          if (!item.tariffList) {
            this.$set(item, "tariffList", [
              {
                startTime: "00:00",
                endTime: "23:59",
                price: ""
              }
            ]);
          }
        });
        // 转成字符串
        this.form.spSiteTypeId = this.form.spSiteTypeId + "";
        this.siteTypeList = resSiteTypeList.data;
        // 所选站点类型详情
        this.siteTypeDetail =
          this.siteTypeList.find(
            item => item.spSiteTypeId == this.form.spSiteTypeId
          ) || {};
        this.countryList = resCountryList.data;
        this.resampleRuleList = resResampleRuleList.data;
        this.loadTypeList = resLoadTypeList.data;
        this.billTypeList = resBillTypeList.data;
        const [
          resRegion,
          resSupplier,
          resMeterType,
          resTimezoneList
        ] = await Promise.all([
          this.$http.get("/base/region/selectList/" + this.form.spCountryId),
          this.$http.get("/base/supplier/selectList/" + this.form.spCountryId),
          this.$http.get(
            "/base/meterType/selectList/" + this.form.spSiteTypeId
          ),
          this.$http.get("/base/timezone/selectList/" + this.form.spCountryId)
        ]);
        // 区域列表
        this.regionList = resRegion.data;
        // supplier list
        this.supplierList = resSupplier.data;
        // meter type list
        this.meterTypeList = resMeterType.data;
        // 时区列表
        this.timezoneList = resTimezoneList.data;
        if (this.form.loadList.length) {
          // 所选站点下的load asset type
          this.loadAssetTypeDetail = (await this.$http.get(
            "/base/assetType/selectListBySiteType/" + this.form.spSiteTypeId
          )).data[0];
          // load model list
          this.modelList = (await this.$http.get(
            "/base/algoModel/selectList/" +
              this.loadAssetTypeDetail.spAssetTypeId
          )).data;
        }
      } else if (viewInfoMode == "system") {
        // 系统
        const [
          resListSystemType,
          resListIOTAccountID,
          resSystemInfo
        ] = await Promise.all([
          this.$http.get("/base/systemType/selectList/" + info.spSiteTypeId),
          this.$http.get("/base/iotPlatform/selectList"),
          this.$http.get("/base/system/info/" + info.spSystemId)
        ]);
        // 系统类型
        this.systemTypeList = resListSystemType.data;
        // IOT Account ID下拉框
        this.IOTAccountIDList = resListIOTAccountID.data;
        // 系统详情
        this.form = resSystemInfo.data;
        this.form.activateFlag = this.form.activateFlag.toString();
        // 系统类型详情
        this.selectedSystemTypeDetail = this.systemTypeList.find(
          item => item.spSystemTypeId == this.form.spSystemTypeId
        );
        const [
          resListSystemModeType,
          resListIOTDevice,
          resListMeter
        ] = await Promise.all([
          this.$http.get(
            "/base/systemModeType/selectListForPlan/" + this.form.spSystemTypeId
          ),
          this.$http.get(
            "/base/iotDevice/selectList/" + this.form.spIotPlatformId
          ),
          this.$http.post("/base/meter/selectList", {
            spSiteId: info.spSiteId,
            spSystemTypeId: this.form.spSystemTypeId
          })
        ]);
        // 系统模式列表
        this.executionModeList = resListSystemModeType.data.filter(item => {
          // 暂时隐藏Energy Saving模式
          return item.modeType != 30;
        });
        this.IOTDeviceList = resListIOTDevice.data;
        // meter list
        this.siteMeterList = resListMeter.data;
        if (this.systemTypeHasCharger) {
          // 有Charger时需要选择CPO Platform
          this.CPOPlatFormList = (await this.$http.get(
            "/base/cpoPlatform/selectList"
          )).data;
        }
        if (this.systemTypeHasBess) {
          // 有BESS时需要选择Ancillary service
          this.ancillaryServiceList = (await this.$http.get(
            "/base/tempConstant/ancillaryServiceSelectList"
          )).data;
        }
        if (this.form.haveAncillaryServiceFlag == 1) {
          this.aggregatorList = (await this.$http.get(
            "/base/aggregatorPlatform/selectList"
          )).data;
        }
      } else if (viewInfoMode == "asset") {
        // 资产
        // IOT Account ID下拉框
        const [resIOT, resAssetInfo] = await Promise.all([
          this.$http.get("/base/iotDevice/selectList/" + info.spIotPlatformId),
          this.$http.get("/base/asset/info/" + info.spAssetId)
        ]);
        this.IOTDeviceList = resIOT.data;
        const data = resAssetInfo.data;
        let assetParam = "";
        for (assetParam in data.assetParams) {
          data[assetParam] = data.assetParams[assetParam];
        }
        if (operateMode == "asset-charging") {
          data.deleteChargerPileList = [];
          data.IOTDeviceIdForDataQuer = data.subscribeSpIotDeviceId;
          data.chargerPileList.forEach(pile => {
            pile.chargerName = pile.pileName;
            pile.maximumRatedPower = pile.pileMaxRunPower;
            pile.code = pile.pileThirdDeviceId;
            pile.IOTDeviceIdForDataQuer = pile.subscribeSpIotDeviceId;
            pile.deleteChargerGunList = [];
            pile.chargerGunList.forEach(gun => {
              gun.connectorName = gun.gunName;
              gun.connectorCode = gun.gunThirdDeviceId;
              gun.maxChargingPower = gun.gunMaxRunPower;
            });
            pile.connectorList = pile.chargerGunList;
          });
          data.chargerList = data.chargerPileList;
        } else if (operateMode == "asset-pv") {
          data.model = data.spAlgoModelId;
          data.IOTDeviceIdForDataQuer = data.subscribeSpIotDeviceId;
          // model list
          this.modelList = (await this.$http.get(
            "/base/algoModel/selectList/" + info.spAssetTypeId
          )).data;
        } else if (operateMode == "asset-bess") {
          data.model = data.spAlgoModelId;
          data.IOTDeviceIdForDataQuer = data.subscribeSpIotDeviceId;
          // model list
          this.modelList = (await this.$http.get(
            "/base/algoModel/selectList/" + info.spAssetTypeId
          )).data;
        }
        this.form = data;
      }
      this.editAssetModalShow = true;
    },
    // 判断system type是否有charger
    systemTypeHasCharger() {
      return this.selectedSystemTypeDetail.haveChargingSystemFlag;
    },
    // 判断system type是否有bess
    systemTypeHasBess() {
      return this.selectedSystemTypeDetail.haveBessFlag;
    },
    isSiteEdit() {
      return this.operateMode == "site-edit";
    },
    // 表单重置
    reset() {
      this.form = {
        deleteMeterList: [],
        deleteTariffList: [],
        deleteLoadList: [],
        deleteChargerList: [],
        meterNumberList: [],
        loadList: [
          {
            assetName: "",
            loadType: "",
            spMeterId: "",
            spAlgoModelId: ""
          }
        ],
        meterList: [
          {
            meterName: "",
            meterNum: "",
            spMeterTypeId: "",
            spElectricitySupplierId: "",
            meterCapacity: "",
            wholeSaleFlag: "",
            tariffList: [
              {
                startTime: "00:00",
                endTime: "23:59",
                price: ""
              }
            ]
          }
        ],
        chargerList: [
          {
            chargerName: "",
            maximumRatedPower: "",
            code: "",
            IOTDeviceIdForDataQuer: "",
            connectorList: [
              {
                connectorName: "Connector A",
                connectorCode: "",
                maxChargingPower: ""
              }
            ]
          }
        ]
      };
      if (this.operateMode.includes("system")) {
        this.form = {
          systemName: "",
          systemType: "",
          meterNumber: "",
          defaultExecutionMode: "",
          pcsPower: "",
          IOTAccountId: "",
          IOTDeviceIdForDataQuer: "",
          IOTDeviceIdForCommandIssuance: "",
          activateFlag: ""
        };
      } else if (this.operateMode == "asset-charging-add") {
        this.form = {
          assetName: "",
          manufacturer: "",
          productModel: "",
          DCModulePower: "",
          IOTDeviceIdForDataQuer: "",
          chargerList: [
            {
              chargerName: "",
              maximumRatedPower: "",
              code: "",
              IOTDeviceIdForDataQuer: "",
              connectorList: [
                {
                  connectorName: "Connector A",
                  connectorCode: "",
                  maxChargingPower: ""
                }
              ]
            }
          ]
        };
      } else if (this.operateMode == "asset-pv-add") {
        this.form = {
          assetName: "",
          manufacturer: "",
          productModel: "",
          maximumRatedPower: "",
          DCModulePower: "",
          solarPanelsNumber: "",
          solarPanelsRatedPower: "",
          firstYearDegradationRate: "",
          linearDegradationRate: "",
          warrantyPeriod: "",
          spAlgoModelId: "",
          IOTDeviceIdForDataQuer: ""
        };
      } else if (this.operateMode == "asset-bess-add") {
        this.form = {
          assetName: "",
          manufacturer: "",
          productModel: "",
          maximumChargingRatedPower: "",
          maximumDischargingRatedPower: "",
          DCModulePower: "",
          batteryCapacity: "",
          warrantyPeriod: "",
          warrantyCyclesNumber: "",
          maxDailyCycle: "",
          coolingTime: "",
          minOperatingTemperature: "",
          maxOperatingTemperature: "",
          beginSoc: "",
          endSoc: "",
          spAlgoModelId: "",
          mdr: "",
          IOTDeviceIdForDataQuer: ""
        };
      }
      this.resetForm("form");
    },
    deletePlan(info) {
      console.log(info, "info");
      // 计划重复，提示
      this.$confirm(
        this.$t("m.deleteConfirmTip") + this.$t("m.plan") + " ?",
        "",
        {
          confirmButtonText: this.$t("m.confirmBtn")
        }
      ).then(() => {
        this.$http
          .post("/event/plan/delete", {
            siteId: info.siteId,
            systemId: info.systemId,
            startDate: this.$dayjs(info.date).format("YYYY-MM-DD")
          })
          .then(res => {
            console.log(res, "delete res");
            this.$message.success(this.$t("m.deletedTip"));
            this.getPlanListByDate();
            this.getCalendarPlanList(
              false,
              this.$dayjs(info.date).format("YYYY-MM-DD")
            );
          });
      });
    },
    isPlanEdit() {
      return this.planOperateMode.includes("edit");
    },
    async handlePlanModeChange(val) {
      this.selectedEditPlanDetail = this.planForm.planList.find(item => {
        return item.key == val;
      });
      console.log(this.selectedEditPlanDetail, "this.selectedEditPlanDetail");
      this.planForm.plan = this.selectedEditPlanDetail.spSystemModeType;
      this.planForm.startTime = this.selectedEditPlanDetail.startTime;
      this.planForm.endTime = this.selectedEditPlanDetail.endTime;
      if (this.planForm.plan == 20) {
        this.descList = (await this.getDescModeByCountryId()).rows;
        this.planForm.desc = this.selectedEditPlanDetail.spSystemModeSonType;
      } else {
        this.planForm.desc = "";
      }
      if (this.planOperateMode == "edit-all") {
        this.planForm.repetition = this.selectedEditPlanDetail.repetitionType;
        this.planForm.weekly = this.selectedEditPlanDetail.dayOfWeek
          .split(",")
          .map(item => {
            return weeklyTextObj[item];
          });
      }
    },
    // 查询选中日期计划列表
    getPlanListByDate() {
      this.$http
        .get("/event/plan/planList", {
          siteId: this.selectedAssetObj.spSiteId,
          startDate: this.$dayjs(this.selectedDataDay).format("YYYY-MM-DD")
        })
        .then(res => {
          console.log("site plan list", res);
          res.data.forEach(item => {
            // item.plansInfoList.sort((a, b) => {
            //   return new Date(a.createTime) - new Date(b.createTime);
            // })
            item.plansInfoList.forEach((plan, planIndex) => {
              plan.infoList.sort((a, b) => {
                return (
                  new Date("2024-01-01 " + a.timeStart) -
                  new Date("2024-01-01 " + b.timeStart)
                );
              });
              if (
                planIndex != item.plansInfoList.length - 1 &&
                plan.infoList.length == 1
              ) {
                plan.infoList.unshift({ ...plan.infoList[0] });
                plan.infoList[0].modeType = 0;
                plan.infoList[1].modeType = 10;
                plan.infoList[0].splitNum = Number(
                  plan.infoList[0].timeStart.split(":")[0]
                );
                plan.infoList[1].splitNum =
                  Number(plan.infoList[1].timeEnd.split(":")[0]) -
                  Number(plan.infoList[1].timeStart.split(":")[0]);
                return;
              }
              plan.infoList.forEach((ele, index) => {
                if (planIndex < item.plansInfoList.length - 1 && !ele.id) {
                  // 除了最后一条，默认模式都不显示
                  ele.modeType = 0;
                } else {
                  ele.modeType = ele.spSystemModeType;
                }
                ele.splitNum =
                  Number(ele.timeEnd.split(":")[0]) -
                  Number(ele.timeStart.split(":")[0]);
                const timezoneDataDetail =
                  timezoneData[this.selectedSiteInfo.timeZoneId][
                    this.selectedDataDay
                  ];
                console.log(timezoneDataDetail, "timezoneDataDetail");
                // 冬令时转夏令时这天，会出现跳过某小时的计划，比如01:00-03:00,实际上没有02:00
                if (
                  timezoneDataDetail &&
                  timezoneDataDetail.type == "DST" &&
                  ele.timeEnd.split(":")[0] >= timezoneDataDetail.num &&
                  ele.timeStart.split(":")[0] < timezoneDataDetail.num
                ) {
                  ele.splitNum = ele.splitNum - 1;
                }
                // // 夏令时转冬令时这天，会出现比如2:00-2:00的计划
                if (timezoneDataDetail && timezoneDataDetail.type == "ST") {
                  if ((ele.timeEnd.split(":")[0] >= timezoneDataDetail.num ||
                  ele.timeStart.split(":")[0] <= timezoneDataDetail.num) && ele.timeStartXiaFlag) {
                    ele.splitNum = ele.splitNum + 1;
                  } else if (ele.timeEnd.split(":")[0] > timezoneDataDetail.num && ele.timeStart.split(":")[0] < timezoneDataDetail.num && !ele.timeStartXiaFlag && !ele.timeEndXiaFlag) {
                    ele.splitNum = ele.splitNum + 1;
                  }
                }
              });
            });
          });
          this.sitePlanList = res.data;
          console.log(this.sitePlanList, "site plan list");
          this.getEventList();
        });
    },
    // 查询所有的计划模式
    getAllModeType() {
      this.$http.get("/base/systemModeType/list").then(res => {
        console.log("all mode type", res);
        this.allModeTypeObj = {};
        res.data.forEach(item => {
          this.allModeTypeObj[item.modeType] = item.modeName;
        });
        this.getCalendarPlanList(false, this.selectedDataDay);
      });
    },
    // 限制结束时间起始点
    limitEndTime(startTime) {
      startTime = startTime || "00:00";
      return this.$dayjs(this.getTimeStamp(startTime) + 60 * 60000).format(
        "HH:mm"
      );
    },
    // 获取时间戳
    getTimeStamp(time) {
      return new Date("2022-01-01 " + time).getTime();
    },
    getModeTypeFromSystemType(spSystemId) {
      let systemDetail = this.systemList.find(item => {
        return item.spSystemId == spSystemId;
      });
      return this.$http.get(
        "/base/systemModeType/selectListForPlan/" + systemDetail.spSystemTypeId
      );
    },
    // 根据选中的系统来查询可添加的模式
    async planFormSelectSystem(val) {
      this.planModeList = (await this.getModeTypeFromSystemType(
        val
      )).data.filter(item => {
        // 暂时隐藏Energy Saving模式
        return item.modeType != 30;
      });
      // 切换系统后，可添加的计划模式改变，如果没有刚刚选中的计划模式，需要重新选择
      this.planForm.planList.forEach(item => {
        if (
          !this.planModeList.includes(ele => {
            return item.plan == ele.modeType;
          })
        ) {
          item.plan = "";
        }
      });
    },
    getDescModeByCountryId() {
      return this.$http.get("/base/countryAncillayService/list", {
        spCountryId: this.planFormSelectedSiteDetail.spCountryId
      });
    },
    // 根据选中的系统来查询可添加的模式
    async planFormSelectPlanType(value, index) {
      if (value == 20) {
        // plan type为Ancillary Service需查询Desc列表
        // 根据选中的站点的国家id来查询对应的计划类型列表
        this.descList = (await this.getDescModeByCountryId()).rows;
        if (this.isPlanEdit()) {
          this.planForm.desc = "";
        } else {
          this.planForm.planList[index].desc = "";
        }
      } else {
        this.descList = [];
        if (this.isPlanEdit()) {
          this.planForm.desc = "";
        } else {
          this.planForm.planList[index].desc = "";
        }
      }
    },
    navSelect(id) {
      // 顶部导航切换 1:Operations;2:Dashboard;3:Statement
      this.selectedTopNav = id;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.eventListFilter.size = val;
      this.getEventList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.eventListFilter.currentPage = val;
      this.getEventList();
    },
    getEventList() {
      let param = {
        date: this.$dayjs(this.selectedDataDay).format("YYYY-MM-DD"),
        siteId: this.selectedSiteInfo.spSiteId,
        pageNumber: this.eventListFilter.currentPage,
        pageSize: this.eventListFilter.size
      };
      if (this.eventListFilter.eventType) {
        param.type = this.eventListFilter.eventType;
      }
      if (this.eventListFilter.system) {
        param.systemId = this.eventListFilter.system;
      }
      this.$http.post("/event/event/result/list", param).then(res => {
        console.log(res, "event list");
        if (!res.data) {
          this.eventList = [];
          this.eventsTopData = {
            total: 0,
            ultraFastCharging: 0,
            ancillaryService: 0
          };
          this.eventListFilter.total = 0;
          return;
        }
        const data = (res && res.data) || [];
        data.list.data.forEach((item, index) => {
          item.no = index + 1;
        });
        this.eventList = data.list.data;
        this.eventListFilter.total = data.list.totalRecords;
        this.eventsTopData = {
          total: data.total,
          ultraFastCharging: data.Charging,
          ancillaryService: data.Ancillary
        };
      });
    },
    // 判断选中日期是否是历史日期
    isHistoryDate() {
      return new Date(this.selectedDataDay + " 23:59:59") < Date.now();
    },
    // 判断选中日期是否是未来日期
    isFutureDate() {
      return new Date(this.selectedDataDay + " 00:00:00") > Date.now();
    },
    handleDateSelect(date, event) {
      if (this.futureTimeLimitSelect(date)) {
        event.stopImmediatePropagation();
        return;
      }
      this.selectedDataDay = this.$dayjs(date).format("YYYY-MM-DD");
      if (this.selectedTopNav == 1 || this.selectedTopNav == 2) {
        // 如果当月是站点/系统上线时间，则不能切换到上月
        if (
          new Date(
            this.$dayjs(date).format("YYYY-MM") + "-01 00:00:00"
          ).getTime() <= new Date(this.onlineDay + " 00:00:00").getTime()
        ) {
          this.prevBtn.style.display = "none";
        } else {
          this.prevBtn.style.display = "block";
        }
        if (
          this.$dayjs(date).format("YYYY-MM") ==
            this.$dayjs(Date.now()).format("YYYY-MM") &&
          this.selectedTopNav == "2"
        ) {
          // 切换到当月后,Dashboard不能显示未来日期,如果是dashboard页面,隐藏切换下个月按钮
          this.nextBtn.style.display = "none";
        } else {
          this.nextBtn.style.display = "block";
        }
      }
      this.getCalendarPlanList(false, this.selectedDataDay);
      if (this.selectedTopNav == "1") {
        if (this.selectedSiteView == "1") {
          this.getPlanListByDate();
        } else {
          this.getEventList();
        }
      } else if (this.selectedTopNav == "2") {
        this.getPlanListByDate();
      }
    },
    isEditAllPlans() {
      return this.planOperateMode == "edit-all";
    },
    backEditPlan() {
      this.planIsSaved = false;
      this.selectedPlanIsDelete = false;
    },
    addPlanOne(index) {
      this.planForm.planList.splice(index + 1, 0, {
        plan: "",
        desc: "",
        startTime: "",
        endTime: ""
      });
    },
    showDeleteOnePlanModal() {
      this.$confirm(this.$t("m.deleteConfirmTip") + "?", "", {
        confirmButtonText: this.$t("m.confirmBtn"),
        cancelButtonText: this.$t("m.cancelBtn"),
        type: "warning"
      })
        .then(() => {
          this.selectedPlanIsDelete = true;
          this.handlePlanSubmit();
        })
        .catch(() => {});
    },
    removePlanOne(index) {
      console.log(index, "index");
      if (this.isPlanEdit()) {
        this.selectedPlanIsDelete = true;
      }
      this.planForm.planList.splice(index, 1);
    },
    showRemovePlanModal(index) {
      this.$confirm(this.$t("m.deleteConfirmTip") + "?", "", {
        confirmButtonText: this.$t("m.confirmBtn"),
        cancelButtonText: this.$t("m.cancelBtn"),
        type: "warning"
      })
        .then(() => {
          this.removePlanOne(index);
        })
        .catch(() => {});
    },
    judgePlanList(arr) {
      let flag = false;
      if (
        arr.filter(item => {
          return !item.plan;
        }).length
      ) {
        // 计划模式未选择
        this.emptyTip(this.$t("m.plan"));
      } else if (
        arr.filter(item => {
          return item.plan == 20 && !item.desc;
        }).length
      ) {
        // Ansillary service需要选择desc
        this.emptyTip(this.$t("m.desc"));
      } else if (
        arr.filter(item => {
          return !item.startTime;
        }).length
      ) {
        // 开始时间未填写
        this.emptyTip(this.$t("m.startTime"));
      } else if (
        arr.filter(item => {
          return !item.endTime;
        }).length
      ) {
        // 结束时间未填写
        this.emptyTip(this.$t("m.endTime"));
      } else if (
        arr.filter(item => {
          return item.endTime <= item.startTime;
        }).length
      ) {
        // 结束时间小于开始时间
        this.$message({
          type: "warning",
          message: this.$t("m.selectIncorrectTip") + this.$t("m.timeRange")
        });
      } else {
        // 判断时间是否重复
        let noRepeat = true;
        for (let i = 0; i < arr.length; i++) {
          for (let j = 0; j < arr.length; j++) {
            if (
              i != j &&
              ((this.getTimeStamp(arr[i].startTime) >=
                this.getTimeStamp(arr[j].startTime) &&
                this.getTimeStamp(arr[i].startTime) <
                  this.getTimeStamp(arr[j].endTime)) ||
                (this.getTimeStamp(arr[i].endTime) >
                  this.getTimeStamp(arr[j].startTime) &&
                  this.getTimeStamp(arr[i].endTime) <=
                    this.getTimeStamp(arr[j].endTime)))
            ) {
              noRepeat = false;
            }
          }
        }
        if (!noRepeat) {
          // 时间选择重复
          this.$message({
            type: "warning",
            message: this.$t("m.timeRepeatTip")
          });
        } else {
          flag = true;
        }
      }
      return flag;
    },
    // 获取站点的计划列表
    getCalendarPlanList(need = false, date) {
      // need: 在新增计划后，动态设置模态框内calendar的头部文案
      let param = {
        siteId: this.selectedAssetObj.spSiteId,
        month: this.$dayjs(date).format("YYYY-MM") + "-01"
      };
      if (this.selectedLevel != "site") {
        param.systemId = this.selectedAssetObj.spSystemId;
      }
      this.$http.get("/event/plan/calendarList", param).then(res => {
        console.log(res, "plan list");
        // res.data: {'2024-01-01': {10: 1, 20: 1}}
        // modalCalendarEventsList: {'2024-01-01': [{mode: 10, title: 'Energy Saving'}, {mode: 20, title: 'Ultra Fast Charging'}]}
        this.modalCalendarEventsList = {};
        for (let date in res.data) {
          this.modalCalendarEventsList[date] = [];
          for (let type in res.data[date]) {
            this.modalCalendarEventsList[date].push({
              mode: type,
              title: this.allModeTypeObj[type]
            });
          }
        }
        this.calendarEventsList = res.data;
        if (need) {
          this.planIsSaved = true;
          this.$nextTick(() => {
            this.setModalCalendarHeader(date);
          });
        }
      });
    },
    // 获取需要编辑的所有计划
    getAllPlanToEdit(param) {
      return this.$http.post("/event/plan/edit/all/list", param);
    },
    editPlanOne() {},
    async handlePlanSubmit() {
      this.$refs["plan-form"].validate(async valid => {
        if (valid) {
          let api = "";
          let param = {};
          let date = "";
          if (this.planOperateMode == "add") {
            // 计划时间结束时间应大于开始时间
            if (!this.judgePlanList(this.planForm.planList)) {
              return;
            }
            api = "/event/plan/create";
            let planTimeObj = {};
            param = {
              siteId: this.planForm.site,
              systemId: this.planForm.system,
              startDate: this.$dayjs(this.planForm.startDate).format(
                "YYYY-MM-DD"
              ),
              endDate:
                this.planForm.repetition !== 0 && this.planForm.endDate
                  ? this.$dayjs(this.planForm.endDate).format("YYYY-MM-DD")
                  : "",
              repetitionVo: {
                type: this.planForm.repetition,
                dayOfWeek:
                  this.planForm.repetition == 20
                    ? this.planForm.weekly.map(item => {
                        return weeklyIdObj[item];
                      })
                    : []
              },
              modeList: this.planForm.planList.map(item => {
                planTimeObj = {
                  modeType: item.plan,
                  sonModeType: item.desc || "",
                  timeStart: item.startTime,
                  timeEnd: item.endTime,
                  timeStartXiaFlag: null,
                  timeEndXiaFlag: null
                };
                if (item.startTime.includes("isFirst")) {
                  planTimeObj.timeStart = item.startTime.split(" ")[0];
                  planTimeObj.timeStartXiaFlag = 1;
                  if (item.endTime.includes("isSecond")) {
                    planTimeObj.timeEnd = item.endTime.split(" ")[0];
                    planTimeObj.timeEndXiaFlag = 0;
                  }
                } else if (item.startTime.includes("isSecond")) {
                  planTimeObj.timeStart = item.startTime.split(" ")[0];
                  planTimeObj.timeStartXiaFlag = 0;
                } else if (item.endTime.includes("isFirst")) {
                  planTimeObj.timeEnd = item.endTime.split(" ")[0];
                  planTimeObj.timeEndXiaFlag = 1;
                } else if (item.endTime.includes("isSecond")) {
                  planTimeObj.timeEnd = item.endTime.split(" ")[0];
                  planTimeObj.timeEndXiaFlag = 0;
                }
                return planTimeObj;
              })
            };
            date = param.startDate;
          } else if (this.planOperateMode == "edit-one") {
            let defaultFlag = 0;
            let spSystemModeType = this.planForm.plan;
            let spSystemModeSonType = this.planForm.desc || "";
            if (
              this.planForm.plan == this.selectedSystemPlanDetail.defaultType
            ) {
              defaultFlag = 1;
            }
            if (this.selectedPlanIsDelete) {
              // 计划删除了
              defaultFlag = 1;
              spSystemModeType = this.selectedSystemPlanDetail.defaultType;
              spSystemModeSonType = "";
            }
            param = {
              date: this.planForm.date,
              siteId: this.planForm.site,
              systemId: this.planForm.system,
              plansInfoList: [
                {
                  infoList: [
                    {
                      spSiteId: this.planForm.site,
                      spSystemId: this.planForm.system,
                      spSystemModeType,
                      timeStart: this.planForm.startTime,
                      timeEnd: this.planForm.endTime,
                      spSystemModeSonType,
                      defaultFlag,
                      id: this.selectedEditPlanDetail.id,
                      spSystemModePlanId: this.selectedEditPlanDetail
                        .spSystemModePlanId
                    }
                  ]
                }
              ]
            };
            api = "/event/plan/edit/one";
            date = param.date;
          } else {
            api = "/event/plan/edit/all/cycle";
            let spSystemModeType = this.planForm.plan;
            let spSystemModeSonType = this.planForm.desc || "";
            if (this.selectedPlanIsDelete) {
              // 计划删除了
              spSystemModeType = this.selectedSystemPlanDetail.defaultType;
              spSystemModeSonType = "";
            }
            param = {
              siteId: this.planForm.site,
              systemId: this.planForm.system,
              startDate: this.$dayjs(this.planForm.startDate).format(
                "YYYY-MM-DD"
              ),
              endDate:
                this.planForm.repetition !== 0 && this.planForm.endDate
                  ? this.$dayjs(this.planForm.endDate).format("YYYY-MM-DD")
                  : "",
              repetitionVo: {
                type: this.planForm.repetition,
                dayOfWeek:
                  this.planForm.repetition == 20
                    ? this.planForm.weekly.map(item => {
                        return weeklyIdObj[item];
                      })
                    : []
              },
              planInfoList: [
                {
                  ...this.selectedEditPlanDetail,
                  modeType: spSystemModeType,
                  spSystemModeType,
                  sonModeType: spSystemModeType,
                  spSystemModeSonType,
                  timeStart: this.planForm.startTime,
                  timeEnd: this.planForm.endTime
                }
              ]
            };
            date = param.startDate;
            delete param.planInfoList[0].startTime;
            delete param.planInfoList[0].endTime;
          }
          console.log(param.modeList, "mode list");
          let res = await this.$http.post(api, param);
          console.log(res, "plan operate");
          this.$message.success(this.$t("m.savedTip"));
          if (res.data && res.data.conflictFlag) {
            // 计划重复，提示
            this.$alert(this.$t("m.planConflictTip"), "", {
              confirmButtonText: this.$t("m.completeBtn")
            })
              .then(() => {
                this.getCalendarPlanList(true, date);
                if (date == this.selectedDataDay) {
                  this.getPlanListByDate();
                }
              })
              .catch(() => {
                this.getCalendarPlanList(true, date);
                if (date == this.selectedDataDay) {
                  this.getPlanListByDate();
                }
              });
          } else {
            this.getCalendarPlanList(true, date);
            if (date == this.selectedDataDay) {
              this.getPlanListByDate();
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    hidePlanModal() {
      this.planModalShow = false;
      this.planIsSaved = false;
      this.selectedPlanIsDelete = false;
    },
    getRepetitionList() {
      return this.$http.get("/event/plan/repetition/list");
    },
    async showPlanModal(mode, planData) {
      console.log(mode, "mode");
      console.log(planData, "planData");
      this.planOperateMode = mode;
      this.selectedSystemPlanDetail = planData;
      this.planRepetitionList = await this.getRepetitionList();
      if (mode == "add") {
        this.planForm = {
          site: this.selectedAssetObj.spSiteId,
          system: "",
          startDate: "",
          mode: "",
          repetition: "",
          endDate: "",
          weekly: [],
          planList: [
            {
              plan: "",
              desc: "",
              startTime: "",
              endTime: ""
            }
          ]
        };
        // 根据选中的站点来查询对应的系统列表
        this.systemList = this.selectedAssetObj.systemList || [];
      } else {
        const planOne = planData.plansInfoList[0].infoList[0];
        console.log(planOne, "plan one");
        // 根据选中的站点来查询对应的系统列表
        this.systemList = this.selectedAssetObj.systemList || [];
        // 根据选中的系统来查询可添加的模式
        this.planModeList = (await this.getModeTypeFromSystemType(
          planOne.spSystemId
        )).data.filter(item => {
          // 暂时隐藏Energy Saving模式
          return item.modeType != 30;
        });
        this.planForm = {
          ...planData,
          site: this.selectedAssetObj.spSiteId,
          system: planOne.spSystemId,
          startDate: planData.date,
          mode: "",
          repetition: "",
          endDate: "",
          weekly: [],
          planList: []
        };
        if (mode == "edit-all") {
          let planList = (await this.getAllPlanToEdit({
            siteId: this.planForm.site,
            systemId: this.planForm.system,
            startDate: this.planForm.startDate
          })).data;
          console.log(planList, "plan list");
          planList.forEach((item, outPlanIndex) => {
            item.planInfoList.forEach((ele, innerPlanIndex) => {
              if (ele.modeType !== 0) {
                this.planForm.planList.push({
                  plan: ele.spSystemModeType,
                  desc: ele.spSystemModeSonType,
                  startTime: ele.timeStart,
                  endTime: ele.timeEnd,
                  name: this.handleEventDetailShow(ele),
                  key: outPlanIndex + "" + innerPlanIndex,
                  ...ele
                });
              }
            });
          });
        } else {
          planData.plansInfoList.forEach((item, outPlanIndex) => {
            item.infoList.forEach((ele, innerPlanIndex) => {
              if (ele.modeType !== 0) {
                this.planForm.planList.push({
                  isConflict: outPlanIndex != planData.plansInfoList.length - 1,
                  plan: ele.spSystemModeType,
                  desc: ele.spSystemModeSonType,
                  startTime: ele.timeStart,
                  endTime: ele.timeEnd,
                  name: this.handleEventDetailShow(ele),
                  key: outPlanIndex + "" + innerPlanIndex,
                  ...ele
                });
              }
            });
          });
        }
      }
      this.handleTimeList();
      this.planModalShow = true;
    },
    // 日历上下月切换
    handleCalendarPrevNext() {
      this.prevBtn.onclick = e => {
        console.log(e, "e");
        this.nextBtn.style.display = "block";
        this.calendarHeaderMonth = new Date(this.calendarHeaderTitle.innerText);
        this.selectedDataDay = this.$dayjs(this.calendarHeaderMonth).format(
          "YYYY-MM-DD"
        );
        console.log(this.selectedDataDay, "selectedDataDay");
        if (this.selectedTopNav == 1 || this.selectedTopNav == 2) {
          // 如果当月是站点/系统上线时间，则不能切换到上月
          if (
            new Date(this.selectedDataDay + " 00:00:00").getTime() <=
            new Date(this.onlineDay + " 00:00:00").getTime()
          ) {
            this.prevBtn.style.display = "none";
          } else {
            this.prevBtn.style.display = "block";
          }
          // 且需要切换到上线日期
          const dateList = document.querySelectorAll(".date-cell p");
          dateList.forEach(item => {
            if (item.getAttribute("data-day") == this.onlineDay) {
              // 切换到上线日期
              item.click();
            }
          });
        }
        // console.log(this.$dayjs(this.calendarHeaderMonth).format("MM"), "mm");
        // 测试欧洲冬夏令时转换
        if (
          this.$dayjs(this.calendarHeaderMonth).format("MM") != "03" &&
          this.$dayjs(this.calendarHeaderMonth).format("MM") != "10"
        ) {
          return;
        }
        this.getPlanListByDate();
        this.getCalendarPlanList(false, this.selectedDataDay);
      };
      this.nextBtn.onclick = e => {
        console.log(e, "e ?????");
        this.onlineDay = this.selectedAssetObj.onlineDay;
        this.prevBtn.style.display = "block";
        this.calendarHeaderMonth = new Date(this.calendarHeaderTitle.innerText);
        if (
          this.$dayjs(this.calendarHeaderMonth).format("MM") ==
            this.$dayjs(Date.now()).format("MM") &&
          this.selectedTopNav == "2"
        ) {
          // 切换到当月后,Dashboard不能显示未来日期,如果是dashboard页面,隐藏切换下个月按钮
          this.nextBtn.style.display = "none";
        } else {
          this.nextBtn.style.display = "block";
        }
        this.selectedDataDay = this.$dayjs(this.calendarHeaderMonth).format(
          "YYYY-MM-DD"
        );
        // console.log(this.$dayjs(this.calendarHeaderMonth).format("MM"), "mm");
        // 测试欧洲冬夏令时转换
        if (
          this.$dayjs(this.calendarHeaderMonth).format("MM") != "03" &&
          this.$dayjs(this.calendarHeaderMonth).format("MM") != "10"
        ) {
          return;
        }
        this.getPlanListByDate();
        this.getCalendarPlanList(false, this.selectedDataDay);
      };
    },
    // 修改日历头部的文字
    setCalendarHeader(needChangeToday = false) {
      // 切换上一月
      this.prevBtn = document.querySelector(
        ".plan-calendar .el-calendar__button-group .el-button-group>button:nth-child(1)"
      );
      // 切换今天
      this.todayBtn = document.querySelector(
        ".plan-calendar .el-calendar__button-group .el-button-group>button:nth-child(2)"
      );
      if (needChangeToday) {
        // 切换到今天
        this.todayBtn.click();
      }
      this.todayBtn.style.display = "none";
      // 切换下一月
      this.nextBtn = document.querySelector(
        ".plan-calendar .el-calendar__button-group .el-button-group>button:nth-child(3)"
      );
      this.calendarHeader = document.querySelector(
        ".plan-calendar .el-calendar__header"
      );
      // 月份显示
      this.calendarHeaderTitle = document.querySelector(
        ".plan-calendar .el-calendar__title"
      );
      this.calendarHeader.style.position = "relative";
      this.calendarHeaderTitle.style.margin = "0 auto";
      this.prevBtn.setAttribute("class", "el-button--text");
      this.prevBtn.lastChild.setAttribute("class", "el-icon-arrow-left");
      this.prevBtn.lastChild.innerHTML = "";
      this.prevBtn.style.position = "absolute";
      this.prevBtn.style.left = "10px";
      this.prevBtn.style.top = "50%";
      this.prevBtn.style.transform = "translateY(-50%)";
      this.prevBtn.style.cursor = "pointer";
      this.nextBtn.setAttribute("class", "el-button--text");
      this.nextBtn.lastChild.setAttribute("class", "el-icon-arrow-right");
      this.nextBtn.lastChild.innerHTML = "";
      this.nextBtn.style.position = "absolute";
      this.nextBtn.style.right = "10px";
      this.nextBtn.style.top = "50%";
      this.nextBtn.style.transform = "translateY(-50%)";
      this.nextBtn.style.cursor = "pointer";
      this.$nextTick(() => {
        this.calendarHeaderMonth = new Date(this.calendarHeaderTitle.innerText);
        console.log(this.calendarHeaderMonth, "month");
        if (
          this.selectedTopNav == "2" &&
          this.$dayjs(this.calendarHeaderMonth).format("MM") ==
            this.$dayjs(Date.now()).format("MM")
        ) {
          // Dashboard不能选择未来日期
          this.nextBtn.style.display = "none";
        } else {
          this.nextBtn.style.display = "block";
        }
        // operations/dashboard页面，根据所选站点/系统的上线时间限制日期的选择
        // 切换到上个月后，判断是否有站点/系统上线日期，如果是需要切换到上线日期，上线日期之前不可选
        if (this.selectedTopNav == 1 || this.selectedTopNav == 2) {
          this.onlineDay = this.selectedAssetObj.onlineDay;
          // 如果当月是站点/系统上线时间，则不能切换到上月
          if (
            new Date(
              this.$dayjs(this.calendarHeaderMonth).format("YYYY-MM-DD") +
                " 00:00:00"
            ).getTime() < new Date(this.onlineDay + " 00:00:00").getTime()
          ) {
            this.prevBtn.style.display = "none";
          } else {
            this.prevBtn.style.display = "block";
          }
        }
        this.handleCalendarPrevNext();
      });
    },
    setModalCalendarHeader(date) {
      // 切换上一月
      let prevBtn = document.querySelector(
        ".modal-plan-calendar .el-calendar__button-group .el-button-group>button:nth-child(1)"
      );
      // 切换今天
      let todayBtn = document.querySelector(
        ".modal-plan-calendar .el-calendar__button-group .el-button-group>button:nth-child(2)"
      );
      todayBtn.style.display = "none";
      // 切换下一月
      let nextBtn = document.querySelector(
        ".modal-plan-calendar .el-calendar__button-group .el-button-group>button:nth-child(3)"
      );
      let calendarHeader = document.querySelector(
        ".modal-plan-calendar .el-calendar__header"
      );
      // 月份显示
      let calendarHeaderTitle = document.querySelector(
        ".modal-plan-calendar .el-calendar__title"
      );
      calendarHeader.style.position = "relative";
      prevBtn.setAttribute("class", "el-button--text");
      prevBtn.lastChild.setAttribute("class", "el-icon-arrow-left");
      prevBtn.lastChild.innerHTML = "";
      prevBtn.style.cursor = "pointer";
      nextBtn.setAttribute("class", "el-button--text");
      nextBtn.lastChild.setAttribute("class", "el-icon-arrow-right");
      nextBtn.lastChild.innerHTML = "";
      nextBtn.style.cursor = "pointer";
      let month = "";
      prevBtn.addEventListener("click", e => {
        month = new Date(calendarHeaderTitle.innerText);
        this.modalselectedDataDay = this.$dayjs(month).format("YYYY-MM-DD");
        this.getCalendarPlanList(false, this.modalselectedDataDay);
      });
      nextBtn.addEventListener("click", e => {
        console.log(e, "e");
        month = new Date(calendarHeaderTitle.innerText);
        this.modalselectedDataDay = this.$dayjs(month).format("YYYY-MM-DD");
        this.getCalendarPlanList(false, this.modalselectedDataDay);
      });
    },
    getSiteList() {
      this.$http.get("/base/site/tree").then(res => {
        console.log(res, "site list");
        this.siteList = res.data;
        if (!this.siteList.length) {
          this.$message.warning(this.$t("m.emptyDataTip"));
          return;
        }
        // 处理站点
        this.siteList.forEach((site, siteIndex) => {
          site.id = siteIndex + "";
          site.level = 1;
          site.levelType = "site";
          // 匹配自定义内容
          site.scopedSlots = {
            title: "site"
          };
          site.name = site.siteName;
          site.type = site.siteTypeName;
          site.capacity = "";
          site.onlineDay = site.siteOnlineDay;
          // 统计该站点所有的光伏资产
          site.solarList = [];
          // 统计该站点所有的储能资产
          site.batteryList = [];
          // 统计该站点所有的充电集
          site.chargingList = [];
          // 统计该站点所有的充电桩
          site.chargerPileList = [];
          // 统计该站点所有的充电枪
          site.chargerGunList = [];
          // 处理system
          site.systemList.forEach((system, systemIndex) => {
            system.id = siteIndex + "" + systemIndex;
            system.level = 2;
            system.levelType = "system";
            system.scopedSlots = {
              title: "system"
            };
            system.name = system.systemName;
            system.type = system.systemTypeName;
            system.capacity = system.pcsPower;
            system.onlineDay = system.systemOnlineDay;
            system.spSiteId = site.spSiteId;
            system.spSiteTypeId = site.spSiteTypeId;
            if (system.assetList && system.assetList.length) {
              // 处理资产
              system.assetList.forEach((asset, assetIndex) => {
                asset.id = siteIndex + "" + systemIndex + assetIndex;
                asset.level = 3;
                asset.name = asset.assetName;
                asset.type = asset.assetTypeName;
                asset.spSystemId = system.spSystemId;
                asset.spSiteId = site.spSiteId;
                asset.spIotPlatformId = system.spIotPlatformId;
                asset.onlineDay = system.onlineDay;
                // 光伏
                if (asset.assetTypeCode == 10) {
                  asset.capacity = asset.pcsPower;
                  asset.levelType = "asset-pv";
                  asset.scopedSlots = {
                    title: "asset-pv"
                  };
                  site.solarList.push(asset);
                }
                // 储能
                if (asset.assetTypeCode == 20) {
                  asset.capacity = asset.pcsPower;
                  asset.levelType = "asset-bess";
                  asset.scopedSlots = {
                    title: "asset-bess"
                  };
                  site.batteryList.push(asset);
                }
                // 充电系统
                if (asset.assetTypeCode == 30) {
                  asset.capacity = asset.pcsPower;
                  asset.levelType = "asset-charging";
                  asset.scopedSlots = {
                    title: "asset-charging"
                  };
                  site.chargingList.push(asset);
                }
                // 处理充电桩
                if (asset.chargerPileList && asset.chargerPileList.length) {
                  asset.chargerPileList.forEach(
                    (chargerPile, chargerPileIndex) => {
                      site.chargerPileList.push(chargerPile);
                      chargerPile.id =
                        siteIndex +
                        "" +
                        systemIndex +
                        assetIndex +
                        chargerPileIndex;
                      chargerPile.level = 4;
                      chargerPile.name = chargerPile.pileName;
                      chargerPile.type = "Terminal";
                      chargerPile.capacity = chargerPile.pileMaxRunPower;
                      chargerPile.scopedSlots = {
                        title: "Terminal"
                      };
                      // 处理充电枪
                      if (
                        chargerPile.chargerGunList &&
                        chargerPile.chargerGunList.length
                      ) {
                        chargerPile.chargerGunList.forEach(
                          (chargeGun, chargerGunIndex) => {
                            // 测试枪的状态
                            chargeGun.state = parseInt(Math.random() * 4);
                            site.chargerGunList.push(chargeGun);
                            chargeGun.id =
                              siteIndex +
                              "" +
                              systemIndex +
                              assetIndex +
                              chargerPileIndex +
                              chargerGunIndex;
                            chargeGun.level = 5;
                            chargeGun.name = chargeGun.gunName;
                            chargeGun.type = "Connector";
                            chargeGun.scopedSlots = {
                              title: "Connector"
                            };
                            site.scopedSlots = {
                              title: "site"
                            };
                            chargeGun.capacity = chargeGun.gunMaxRunPower;
                          }
                        );
                      }
                      chargerPile.children = chargerPile.chargerGunList;
                    }
                  );
                  asset.children = asset.chargerPileList;
                }
              });
              system.children = system.assetList;
            }
          });
          // 处理load
          site.loadList.forEach((load, loadIndex) => {
            load.id = siteIndex + "" + (loadIndex + site.systemList.length);
            load.level = 2;
            load.levelType = "load";
            load.scopedSlots = {
              title: "load"
            };
            load.name = load.assetName;
            load.type = load.assetTypeName;
            load.onlineDay = site.onlineDay;
          });
          site.children = [...site.systemList, ...site.loadList];
        });
        this.total = res.data.total;
        this.selectedAssetObj = this.siteList[0];
        this.selectedSiteInfo = this.siteList[0];
        this.systemList = this.selectedSiteInfo.systemList;
        this.getCurrentTime();
      });
    },
    selectFunc(func) {
      this.$emit("selectFunc", func);
    },
    // 储能
    isBattery(type) {
      return type == 10;
    },
    // 光伏
    isPV(type) {
      return type == 20;
    },
    // 负荷
    isLoad(type) {
      return type == 30;
    },
    // 充电集
    isCharger(type) {
      return type == 40;
    },
    // 当前选择时间是否是今天
    isToday() {
      return (
        this.$dayjs(this.selectedca).format("YYYY-MM-DD") ==
        this.$dayjs(Date.now()).format("YYYY-MM-DD")
      );
    },
    // 当前选择时间是否是明天
    isTomorrow() {
      return (
        new Date(this.selectedDataDay).setHours(0, 0, 0, 0) >
        new Date().setHours(0, 0, 0, 0)
      );
    },
    changeTooltipShow(target, value) {
      this.tooltipShowObj[target] = value;
    },
    // 判断当前选中情况
    judgeCurrentType(type) {
      if (this.selectedLevel == "site") {
        if (
          this.selectedAssetObj.assetList &&
          this.selectedAssetObj.assetList.findIndex(item => {
            return item.assetsType == type;
          }) != -1
        ) {
          return true;
        }
      } else if (this.selectedAssetInfo.assetsType == type) {
        return true;
      }
      return false;
    },
    // 树结构上选择站点或资产
    selectSiteOrAsset(info) {
      if (info.levelType == "site") {
        // 选中了站点
        if (this.selectedSiteInfo.spSiteId != info.spSiteId) {
          this.selectedSiteInfo = info;
          this.systemList = info.systemList;
          // this.getCurrentTime();
        }
      } else {
        if (this.selectedTopNav == "1" || this.selectedTopNav == "3") {
          // operations, statement页面，系统、资产不可选
          return;
        }
      }
      this.selectedAssetObj = info;
      console.log(this.selectedAssetObj, "selectedAssetObj");
      this.selectedLevel = info.levelType;
      this.selectedAssetId = info.spSitesId;
      this.selectedSiteInfo = this.siteList.find(item => {
        return item.spSiteId == this.selectedAssetObj.spSiteId;
      });
      if (this.selectedTopNav == "1" || this.selectedTopNav == "2") {
        this.getCurrentTime();
      }
    },
    // 获取站点对应时区的当前时间
    getCurrentTime() {
      this.setCalendarHeader(true);
      this.realTime = this.$dayjs(
        this.$utcToZonedTime(
          // this.getUTCTime(),
          Date.now(),
          this.selectedSiteInfo.timeZoneId
        )
      ).format("HH:mm:ss");
      this.realDate = this.$dayjs(
        this.$utcToZonedTime(
          // this.getUTCTime(),
          Date.now(),
          this.selectedSiteInfo.timeZoneId
        )
      ).format("DD MMM YYYY");
      this.selectedDataDay = this.realDate;
      this.getPlanListByDate();
      this.getAllModeType();
      let arr = this.realTime.split(":");
      this.currentMinute = arr[0] * 60 + arr[1];
      this.timer && clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.realTime = this.$dayjs(
          this.$utcToZonedTime(
            // this.getUTCTime(),
            Date.now(),
            this.selectedSiteInfo.timeZoneId
          )
        ).format("HH:mm:ss");
        this.realDate = this.$dayjs(
          this.$utcToZonedTime(
            // this.getUTCTime(),
            Date.now(),
            this.selectedSiteInfo.timeZoneId
          )
        ).format("DD MMM YYYY");
        arr = this.realTime.split(":");
        this.currentMinute = arr[0] * 60 + Number(arr[1]);
      }, 1000);
    },
    handleCalendarSelect() {
      this.calendarList = [
        {
          date: this.selectedDataDay,
          className: "special"
        }
      ];
    },
    changeDeleteAssetModal(val, item, mode) {
      this.deleteModalShow = val;
      if (val) {
        this.selectedDeleteAsset = item;
        this.selectedDeleteMode = mode;
      }
    },
    changeSiteView(id) {
      this.selectedSiteView = id;
      if (id == "2") {
        // event
        this.getEventList();
      }
    },
    changeOperateShow(item) {
      this.siteList.forEach(ele => {
        if (item.spSitesId == ele.spSitesId) {
          ele.operateShow = !ele.operateShow;
        }
      });
    },
    changeAssetOperateBoxShow(item) {
      this.siteList.forEach(ele => {
        ele.assetList.forEach(self => {
          self.assetList.forEach(asset => {
            if (item.spAssetsId == asset.spAssetsId) {
              asset.operateShow = !asset.operateShow;
            }
          });
        });
      });
    },
    chartResize() {
      console.log("test");
      this.chartResizeTimer && clearTimeout(this.chartResizeTimer);
      this.chartResizeTimer = setTimeout(() => {
        this.charts && this.charts.resize();
        this.chartsSOC && this.chartsSOC.resize();
      }, 600);
    }
  }
};
</script>

<style lang="scss">
@import "../assets/scss/variables.scss";
.plan-operate-popper {
  width: 120px !important;
  min-width: 120px !important;
  p {
    &:hover {
      background-color: #e6f7ff;
    }
  }
}
.el-button--primary {
  background-color: #59a1e1 !important;
  border-color: #59a1e1 !important;
  &:hover {
    color: #fff !important;
  }
}
.plan-one-operate-popper {
  .el-button {
    color: $normalColor;
    margin-right: 0.1rem;
  }
}
.tariff-tooltip {
  width: 400px;
}
.el-picker-panel {
  background-color: rgba(27, 29, 36, 1);
  border-color: rgba(221, 224, 231, 0.4);
  .popper__arrow {
    border-bottom-color: rgba(221, 224, 231, 0.4) !important;
    &::after {
      border-bottom-color: rgba(221, 224, 231, 0.4) !important;
    }
  }
  .el-date-table {
    th {
      border-bottom: none;
    }
  }
}
.is-conflict {
  color: #fa6400 !important;
  input {
    color: #fa6400 !important;
  }
}
.page-assets {
  .energySaving {
    background-color: #00a5df;
  }
  .ultraFastCharging {
    background-color: rgba(0, 178, 169, 1);
    &.future-time {
      background-color: rgba(0, 178, 169, 0.5);
    }
  }
  .AncillaryService {
    background-color: #999;
  }
  .page-assets-content {
    background: #f9f9f9;
    height: calc(100% - 0.54rem);
  }
  .sites-title-box {
    padding: 0 0.3rem;
    height: 0.54rem;
    h4 {
      font-weight: 600;
      color: $normalColor;
      font-size: 0.18rem;
      margin-bottom: 0;
    }
    i {
      color: $activeBgColor;
      &.el-icon-location-information {
        font-weight: bold;
      }
    }
  }
  .el-table {
    .cell {
      font-size: 0.12rem;
    }
  }
  .country-asset-box {
    width: 280px;
    flex-grow: 0;
    flex-shrink: 0;
    .logo-box {
      text-align: center;
      height: 0.54rem;
      padding-top: 0.07rem;
      .logo {
        height: 0.4rem;
      }
    }
    .country-asset-list {
      height: calc(100%);
      overflow-y: auto;
    }
  }
  .charts-data-content {
    height: calc(100%);
    overflow-y: auto;
    padding-bottom: 0.2rem;
    flex: 1;
    .header {
      height: 0.4rem;
    }
    .live-monitor-box {
      margin-top: 0.2rem;
    }
    .site-plan-table {
      .el-row {
        height: 0.14rem;
        // padding-right: 0.3rem;
        padding-left: 0.2rem;
        position: relative;
        &.time-list {
          height: 0.2rem;
        }
        .special-time {
          font-size: 0.12rem;
          position: absolute;
          right: 0;
          transform: translateX(-50%);
        }
        .time {
          font-size: 0.12rem;
          display: inline-block;
          transform: translateX(-50%);
          text-align: center;
        }
        .event-one {
          display: inline-block;
          height: 0.1rem;
        }
      }
      .el-col {
        height: 0.1rem;
        .time {
          font-size: 0.12rem;
          display: inline-block;
          transform: translateX(-50%);
        }
      }
      .grid-content {
        // border-radius: 4px;
        height: 100%;
        position: relative;
      }
      .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
      }
      .mode-text {
        font-size: 0.12rem;
      }
    }
  }
  .calendar-box {
    width: 2.6rem;
    flex-shrink: 0;
    padding: 0 0.2rem;
    box-sizing: border-box;
    .current-time-box {
      background-color: #fff;
      margin: 0.2rem 0;
      padding: 0.1rem 0.2rem;
      .time-text {
        color: #111;
      }
      .time-value {
        font-size: 0.26rem;
        font-weight: bold;
        color: #333;
      }
    }
    .el-calendar__body {
      td {
        p {
          height: 0.26rem;
        }
        &.current {
          color: #111;
        }
        &.is-today {
          color: #00a5df;
          p {
            border: 1px solid #00a5df;
            box-sizing: border-box;
          }
        }
        &.is-selected {
          background: none;
          p {
            background-color: #00a5df;
            color: #fff;
          }
        }
      }
    }
    .create-plan-btn {
      width: 100%;
      margin-top: 0.2rem;
      i {
        margin-right: 0.1rem;
      }
    }
    .mode-list {
      flex-wrap: wrap;
      background-color: #fff;
      padding: 0.2rem;
      border-top: 1px solid #eff2f3;
      .mode-one {
        margin-right: 0.1rem;
      }
      .mode-cycle {
        width: 0.1rem;
        height: 0.1rem;
        border-radius: 50%;
        display: inline-block;
        margin-right: 0.1rem;
      }
    }
    .el-calendar__body {
      padding: 0.1rem;
      thead {
        th {
          font-size: 0.14rem;
          text-align: center;
        }
      }
      tbody {
        tr {
          td {
            border: none;
          }
        }
      }
    }
    .el-calendar-day {
      height: 0.4rem;
      text-align: center;
      padding: 0;
      position: relative;
      &:hover {
        background: none;
      }
      .date-cell {
        height: 100%;
        &:hover {
          background-color: #f2f8fe;
        }
        &.disabled {
          cursor: default;
          color: #c0c4cc;
          &:hover {
            background: none;
          }
        }
      }
    }
    .event-box {
      position: absolute;
      bottom: 0.06rem;
      width: 100%;
    }
    .event-one {
      width: 0.06rem;
      height: 0.06rem;
      border-radius: 50%;
      &.energySaving {
        background-color: #00a5df;
      }
      &.ultraFastCharging {
        background-color: #00b2a9;
      }
      &.AncillaryService {
        background-color: #999;
      }
    }
  }
  .events-box {
    background-color: #fff;
    margin-left: 0.2rem;
    height: calc(100% - 2.2rem);
    padding: 0.4rem;
    .no-data-box {
      height: 100%;
      text-align: center;
    }
  }
  .dashboard-box {
    padding: 0.1rem 0.2rem 0 0.2rem;
    background-color: #fff;
    margin-left: 0.2rem;
    height: calc(100% - 2.2rem);
    .el-table {
      .operate {
        img {
          margin-right: 0.1rem;
        }
      }
    }
  }
  .info-list {
    &.operations-info-list {
      margin-left: 0.2rem;
      padding: 0.2rem;
      background-color: #fff;
    }
  }
  .benefits {
    .info-one {
      width: 100%;
    }
    .param-box {
      width: 50%;
      &.w-100 {
        width: 100%;
      }
      &.ancillary-service {
        position: relative;
        padding-left: 0.2rem;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          height: 50%;
          width: 1px;
          background-color: $borderColor;
        }
      }
    }
  }
  .info-one {
    box-shadow: $boxShadow;
    border-radius: 0.08rem;
    border: 1px solid $borderColor;
    padding: 0.2rem;
    p {
      color: #111;
    }
    .param-name {
      font-size: 0.14rem;
    }
    .param-value {
      font-size: 0.28rem;
    }
  }
  .events-box {
    .el-pagination {
      float: right;
      margin-top: 0.4rem;
    }
  }
  .live-monitor-box {
    height: calc(100% - 0.54rem - 0.4rem);
    margin: 0 0.2rem;
    padding: 0.1rem 0.2rem;
    box-shadow: $boxShadow;
  }
  .configuration-box {
    height: calc(100% - 0.68rem);
    padding: 0 0.2rem;
    flex: 1;
  }
  .infos-box {
    .info-one-box {
      width: 18%;
      margin-right: 2%;
      background-color: #fff;
      border-radius: 5px;
      box-shadow: 0px 0px 4px 0px $borderColor;
      position: relative;
      padding-left: 0.2rem;
      img {
        width: 0.36rem;
        height: auto;
      }
      &:last-child {
        margin-right: 0;
      }
      .el-icon-more {
        transform: rotateZ(90deg);
        font-size: 0.2rem;
        color: $activeBgColor;
        cursor: pointer;
      }
      .dispatch-chart {
        width: 1rem;
        height: 1rem;
        margin: 0 0.1rem;
        flex-shrink: 0;
      }
      p {
        margin-bottom: 0;
      }
      .param-content {
        height: 0.8rem;
        & > div {
          .param-name {
            display: inline-block;
            width: 1rem;
          }
        }
      }
      &.time-box {
        .month-year {
          color: $activeBgColor;
          font-size: 0.16rem;
          font-weight: bold;
        }
        i {
          background: #d7edf9;
          color: $activeBgColor;
          &.el-icon-arrow-left {
            margin-right: 0.1rem;
          }
        }
        .day-value {
          color: $activeBgColor;
          font-size: 0.3rem;
          font-weight: bold;
          background: #d7edf9;
          margin-top: 0.1rem;
          display: inline-block;
        }
        .time-value {
          margin-top: 0.1rem;
          color: $activeBgColor;
          font-size: 0.3rem;
          font-weight: bold;
          &.hidden {
            visibility: hidden;
          }
        }
        .day-text,
        .time-text {
          color: #666;
          font-size: 0.14rem;
        }
        .back-today {
          color: $activeBgColor;
        }
        .date-select {
          position: absolute;
          bottom: 0rem;
          transform: translateY(100%);
          z-index: 99;
          padding-top: 0.1rem;
        }
        .wh_container {
          box-shadow: 0px 2px 8px 0px rgba(51, 51, 51, 0.2);
          .wh_content_all {
            background: #fff;
          }
          .wh_top_tag,
          .wh_top_changge li {
            color: $normalColor;
          }
          .wh_top_tag {
            width: 0.3rem;
            height: 0.3rem;
          }
          .wh_jiantou1,
          .wh_jiantou2 {
            border-color: $normalColor;
          }
          .wh_content_item {
            font-size: 0.12rem;
            height: 0.3rem;
            .wh_item_date {
              height: 0.3rem;
              width: 0.3rem;
              color: $normalColor;
              &.wh_want_dayhide {
                background-color: $borderColor;
                color: #fff;
                cursor: not-allowed;
              }
              &.special {
                background-color: $activeBgColor !important;
                border-radius: 50%;
                color: #fff;
                &.wh_isToday {
                  color: #fff;
                }
              }
            }
            .wh_chose_day {
              color: #fff !important;
              background: $activeBgColor !important;
            }
            .wh_isToday {
              background: none;
            }
          }
          .wh_item_date:hover {
            background-color: $activeBgColor;
            color: #fff;
          }
        }
      }
      &.power-generation {
        .unit {
          font-size: 0.14rem;
          margin-left: 0.1rem;
        }
        .param-value {
          color: #f7b500;
        }
        .tool-param-value {
          color: $normalColor;
          font-size: 0.16rem;
          font-weight: bold;
        }
        .line {
          width: 1px;
          height: 0.5rem;
          background-color: rgba(151, 151, 151, 0.2);
        }
        &.type-bess {
          width: 30%;
          .content > div > div {
            width: 48%;
            .battery-charging {
              color: #00a867;
            }
            .battery-discharging {
              color: #ff9e1b;
            }
          }
          .line {
            margin: 0 10%;
          }
        }
        &.type-load {
          .param-value {
            color: #999;
          }
        }
        &.solar-charge {
          width: 18%;
          .param-value {
            color: #333;
          }
        }
        &.battery-charge-discharge {
          width: 30%;
          .content > div > div {
            width: 48%;
            .param-value {
              color: #333;
            }
          }
          .line {
            margin: 0 10%;
          }
        }
        &.load-from {
          width: 50%;
          .content > div > div {
            width: 24%;
            .param-value {
              color: #333;
            }
          }
          .line {
            margin: 0 10%;
          }
        }
        &.energy-storage-charge-and-discharge {
          width: 30%;
          .content > div > div {
            width: 50%;
          }
          .discharge-value {
            padding-left: 0.4rem;
            .param-value {
              color: #ff9500;
            }
          }
          .charge-value {
            color: #00a5df;
          }
          .param-name {
            display: inline-block;
            min-width: 0.7rem;
          }
        }
        &.charge-terminal {
          width: 20%;
          .param-value {
            color: #0ca2c3;
          }
        }
        &.charge-pile {
          max-width: 60%;
          overflow-x: auto;
          padding: 0;
          .param-value {
            color: #333;
          }
          .content {
            overflow-x: auto;
            padding: 0.1rem 0 0.1rem 0;
          }
          .charge-pile-one {
            position: relative;
            width: 33%;
            flex-shrink: 0;
            padding-left: 0.4rem;
            &:not(:last-child) {
              &::after {
                content: "";
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 1px;
                height: 0.5rem;
                background-color: rgba(151, 151, 151, 0.2);
              }
            }
          }
        }
        &.type-solar {
          .param-value {
            color: #ffb200;
          }
        }
        &.type-charging {
          .param-value {
            color: #00b2a9;
          }
        }
        span {
          font-size: 0.12rem;
        }
        p {
          font-size: 0.14rem;
        }
      }
      .content {
        overflow: hidden;
        position: relative;
        padding: 0.1rem;
        width: 100%;
        height: 100%;
        .param-value {
          font-weight: bold;
          font-size: 0.3rem;
        }
        .discharge-box {
          margin-left: 0.2rem;
        }
        .icon {
          display: inline-block;
          width: 0.08rem;
          height: 0.08rem;
          border-radius: 2px;
          margin-right: 0.06rem;
          &.gray {
            background-color: #999;
          }
          &.green {
            background-color: #00a868;
          }
          &.blue {
            background-color: #32c5ff;
          }
          &.yellow {
            background-color: #f7b500;
          }
          &.purple {
            background-color: #ba38c7;
          }
        }
        .param-name {
          margin-right: 0.1rem;
          color: #7c8d9d;
        }
        p {
          position: relative;
          z-index: 2;
          font-size: 0.14rem;
        }
        &:last-child {
          margin-right: 0;
        }
        & > i {
          position: absolute;
          right: 0;
          bottom: 0;
          color: rgba(42, 49, 51, 0.8);
          font-size: 0.8rem;
          transform: translate(30%, 30%);
          z-index: 1;
          &.el-icon-sort {
            transform: translate(20%, 20%) rotate(90deg);
          }
        }
      }
    }
  }
  .asset-list {
    // padding: 0.2rem 0;
    height: calc(100% - 0.54rem);
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.06);
    h4 {
      margin: 0.2rem;
      padding-top: 0.2rem;
    }
    .title-box {
      // padding: 0 0.2rem;
      padding-left: 0.2rem;
      padding-right: 0.1rem;
      height: 0.4rem;
      line-height: 0.4rem;
    }
    .title-text {
      font-size: 0.12rem;
      display: inline-block;
      width: 50%;
      // margin-bottom: 0.2rem;
      &.rated-power {
        width: calc(50% - 0.46rem);
        margin-right: 0.1rem;
      }
      &.status-title {
        width: auto;
      }
    }
    .asset-type-box {
      padding-left: 0.6rem;
      height: 0.68rem;
      &:hover {
        background: $activeBgColor;
        span,
        i,
        p {
          color: #fff !important;
        }
      }
      .asset-type-name {
        color: #333;
        line-height: 0.68rem;
      }
      .asset-type-img {
        width: 0.48rem;
        margin-right: 0.1rem;
      }
    }
    .asset-list-content {
      height: calc(100% - 0.8rem);
      overflow-y: auto;
      .ant-tree {
        padding: 0 0.2rem;
        .el-icon-view {
          margin-left: 0.1rem;
          cursor: pointer;
        }
        // 没有子节点的icon
        .ant-tree-switcher-noop {
          display: none;
        }
        // 有子节点的可切换icon
        .ant-tree-switcher {
          background: none;
        }
        // 自定义内容
        .ant-tree-title {
          & > div {
            display: flex;
            align-items: center;
          }
          // 图标
          i {
            margin-right: 0.1rem;
            width: 14px;
            height: 14px;
          }
          // 图片
          img {
            width: 14px;
            height: 14px;
            margin-right: 0.1rem;
          }
          .selected {
            color: #00a5df;
          }
          & > div:not(.tree-disabled) {
            &:hover {
              background-color: #e6f7ff;
            }
          }
        }
        // 树结构
        .ant-tree-node-content-wrapper {
          // 选中的样式
          &.ant-tree-node-selected {
            // color: #00a5df;
            background: none;
          }
          // hover的样式
          &:hover {
            background: none;
          }
        }
        .tree-disabled {
          color: #cfd8db;
          cursor: default;
        }
      }
    }
  }

  .charts-list {
    margin-top: 0.2rem;
  }
  .charts-data {
    flex: 1;
    width: calc(100% - 260px);
    .header {
      width: 100%;
      padding: 0 0.2rem;
      margin-top: 0.2rem;
      .header-content {
        border-radius: 0.06rem;
        width: 100%;
        padding-left: 0.2rem;
      }
      .expected-income {
        margin-right: 0.1rem;
      }
      .edit-time {
        margin-left: 0.1rem;
      }
      .event-filter-box {
        box-shadow: $boxShadow;
        color: #333;
        height: 0.3rem;
        margin-top: 0.05rem;
        cursor: pointer;
        background-color: #fff;
        position: relative;
        .filter-out-btn {
          height: 0.3rem;
          padding: 0 0.1rem;
          &:hover {
            border-color: #35383f;
          }
        }
        img {
          margin-right: 0.1rem;
        }
        .event-filter-popover {
          position: absolute;
          bottom: -0.1rem;
          right: 0;
          transform: translateY(100%);
          width: 2.4rem;
          box-shadow: $boxShadow;
          padding: 0.2rem;
          z-index: 999;
          background-color: #fff;
          .el-select {
            &:first-child {
              margin-bottom: 0.2rem;
            }
          }
          input {
            color: #333;
          }
          .el-button {
            display: block;
            width: 100%;
            margin: 0;
            height: 40px;
            &.filter-btn {
              margin: 0.2rem 0;
            }
            &.reset-btn {
              background: none !important;
              &:hover {
                color: #00a5df !important;
              }
            }
          }
        }
      }
    }
    .cycle {
      padding: 0 0.1rem;
      cursor: pointer;
      color: $normalColor;
      margin-left: 0.1rem;
      background-color: $borderColor;
      height: 100%;
      border-radius: 2px;
      box-shadow: 0px 1px 8px 0px rgba(0, 165, 223, 0.1);
      border-radius: 4px 4px 0px 0px;
      span {
        height: auto !important;
        color: #fff;
      }
      &.active {
        background: $activeBgColor;
        span {
          color: #fff;
        }
      }
    }
  }
  .empty-box {
    cursor: pointer;
    height: 100%;
    span {
      text-decoration: underline;
    }
  }
  .modal {
    &.plan-modal {
      .modal-body {
        width: 10rem;
        overflow-y: auto;
        .el-calendar-day {
          padding: 0;
          p:first-child {
            padding-left: 0.06rem;
          }
        }
        h4 {
          .el-icon-arrow-left {
            margin-right: 0.1rem;
          }
        }
        .event-one {
          font-size: 0.12rem;
          color: #fff;
          margin-bottom: 0.06rem;
          padding-left: 0.06rem;
          &:last-child {
            margin-bottom: 0;
          }
        }
        .el-form {
          label {
            display: block;
            float: none;
            width: 100% !important;
            text-align: left;
            font-size: 0.16rem;
          }
          .el-form-item__label {
            font-size: 0.16rem;
          }
          .el-select,
          .el-input {
            width: 100%;
            &.is-disabled {
              input {
                background-color: #eee !important;
              }
            }
          }
          .plans {
            height: 3rem;
            width: 100%;
            overflow-y: auto;
            margin-bottom: 0.2rem;
          }
          .plan-one {
            margin-bottom: 22px;
          }
          .time-between {
            .el-form-item__label {
              float: none;
              text-align: left;
            }
            .sign {
              text-align: center;
              line-height: 40px;
            }
          }
          .operate {
            height: 100%;
            position: absolute;
            right: 0;
            bottom: 0;
            .img-delete {
              position: absolute;
              right: 10px;
              bottom: 11px;
            }
          }
          .el-icon-more {
            transform: rotate(90deg);
            position: absolute;
            right: 10px;
            bottom: 11px;
          }
          .el-checkbox-group {
            label {
              width: auto !important;
            }
            .el-checkbox-button__inner {
              border-color: $borderColor;
              color: $borderColor;
            }
            .el-checkbox-button.is-checked {
              .el-checkbox-button__inner {
                border-color: $activeBgColor;
                color: $activeBgColor;
                background: none;
              }
            }
          }
        }
      }
    }
    &.charging-record-modal {
      .modal-body {
        width: 12rem;
      }
    }
    &.delete-asset-modal {
      .modal-body {
        width: 8rem;
        padding: 0.4rem 0;
        text-align: center;
        p {
          margin-bottom: 0.2rem;
        }
      }
    }
    &.page-edit-site {
      .modal-body {
        width: 16rem;
      }
    }
    &.asset-edit-modal {
      .modal-body {
        height: 80%;
        width: 12rem;
        padding: 0.2rem;
        .modal-header {
          height: 0.4rem;
          margin-bottom: 0;
          padding: 0 0.4rem;
        }
        h4 {
          font-size: 0.24rem;
        }
        .modal-content {
          height: calc(100% - 0.5rem);
          overflow-y: auto;
          padding: 0 0.4rem;
        }
        .el-form-item__label {
          float: none;
          font-size: 0.16rem;
          text-align: left;
        }
        .el-select {
          width: 100%;
        }
        .el-input {
          width: 100%;
        }
        .meter-one {
          margin-bottom: 22px;
        }
        .sign {
          text-align: center;
          line-height: 36px;
          width: 4%;
          display: inline-block;
        }
        .tariff-one {
          margin-bottom: 0.1rem;
        }
        .temperature-input {
          width: 48%;
        }
      }
    }
    .modal-body {
      padding: 0.2rem 0.2rem;
      box-shadow: $boxShadow;
      border-radius: 4px;
      position: relative;
      .modal-header {
        margin-bottom: 0.2rem;
        margin-top: 0.1rem;
      }
      .el-icon-error {
        position: absolute;
        top: 0.2rem;
        right: 0.2rem;
        font-size: 0.32rem;
        cursor: pointer;
      }
      // .el-date-editor {
      //   margin-left: 0.2rem;
      // }
      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: #017dd9;
      }
      .el-radio-button__inner {
        background: none;
        border-color: #393c47;
        width: 0.9rem;
      }
      input {
        background: none;
      }
      .el-range-separator {
        color: #606266;
      }
    }
  }
}
</style>
